/* arturell-fasttrack.js · Fast Track · Stand a6de467052 · Quelle ~/Arturell/fasttrack/src (build.py) */
window.FT_BUILD = "a6de467052";
/* ═══ FAST TRACK NETZ-BAUSTEINE (eingefroren, NICHT von Hand aendern) ═══
   Neu einfrieren nur bewusst: python3 ~/Arturell/fasttrack/einfrieren.py --schreiben
   Jeder Block prueft selbst, ob er schon existiert. ═══ */
/* ── EINGEFROREN: HEIC-Fix ──
   Herkunft: assets/arturell-product.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme f6945508ba9d
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
window.apHeicFix = window.apHeicFix || function(file){
  var isH = /heic|heif/i.test(file.type||'') || /\.(heic|heif)$/i.test(file.name||'');
  if(!isH) return Promise.resolve(file);
  function lib(){
    if(window.heic2any) return Promise.resolve();
    return new Promise(function(res,rej){ var s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js'; s.onload=res; s.onerror=rej; document.head.appendChild(s); });
  }
  return lib().then(function(){ return window.heic2any({blob:file, toType:'image/jpeg', quality:0.92}); })
    .then(function(b){ if(Array.isArray(b)) b=b[0];
      return new File([b], (file.name||'foto').replace(/\.(heic|heif)$/i,'')+'.jpg', {type:'image/jpeg'}); })
    .catch(function(){
      var en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(en?'This photo is in HEIC format and could not be converted. Please share it from your gallery as JPG.':'Dieses Foto ist im HEIC-Format und konnte nicht umgewandelt werden. Bitte aus der Galerie als JPG teilen.');
      return null; });
};

/* ── EINGEFROREN: Geraete-ID ──
   Herkunft: assets/arturell-product.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme 2dd7d550a616
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
if(!window.apDevId){
/* Geraete-ID: zufaellig, damit der Server je Geraet zaehlen kann. */
window.apDevId=function(){
  try{
    var d=localStorage.getItem('apDevId');
    if(!d){ d=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():('d'+Date.now()+'-'+Math.random().toString(36).slice(2,10)); localStorage.setItem('apDevId',d); }
    return d;
  }catch(e){ return ''; }
};

}
/* ── EINGEFROREN: Grant (Mail-Freischaltung) ──
   Herkunft: assets/arturell-product.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme 22abb75774c2
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
if(!window.apGrant){
/* Grant = signierter Nachweis der Mail-Bestaetigung (vom Worker /mailgate/verify) */
window.apGrant=function(){ try{ return localStorage.getItem('apMailGrant')||''; }catch(e){ return ''; } };
}
/* ── EINGEFROREN: Job-Queue (apJobSenden/apJobWarten/apJobGemerkt) ──
   Herkunft: assets/arturell-product.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme 53e95449be0a
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
/* ── APP-WECHSEL-FIX 25.10.2026: Generierung als Hintergrund-Job ──
   Das Theme schickt eine Job-ID mit. Neuer Worker: antwortet sofort "laeuft", das
   Ergebnis wird per GET /job abgeholt — auch wenn der Kunde zwischendurch die App
   wechselt oder die Seite neu laedt. Alter Worker: antwortet wie bisher direkt mit
   dem Ergebnis (rueckwaertskompatibel). fertig(d) bekommt IMMER die Antwort im
   bisherigen Format; d===null heisst Netzfehler. Steht identisch in
   arturell-product.js und arturell-family.js (die erste geladene gewinnt). */
(function(){
  if (window.apJobSenden) return;
  var WK='https://arturell-preview.arturell.workers.dev';
  var KEY='apJob', HALTEN=60*60*1000;
  function neueId(){
    try{ var a=new Uint8Array(16); crypto.getRandomValues(a); var s=''; for(var i=0;i<a.length;i++){ s+=('0'+a[i].toString(16)).slice(-2); } return s; }
    catch(e){ return (Date.now().toString(36)+Math.random().toString(36).slice(2)+Math.random().toString(36).slice(2)).replace(/[^a-z0-9]/g,'').slice(0,32); }
  }
  function merke(o){ try{ if(o) localStorage.setItem(KEY, JSON.stringify(o)); else localStorage.removeItem(KEY); }catch(e){} }
  window.apJobGemerkt=function(){
    try{ var o=JSON.parse(localStorage.getItem(KEY)||'null'); if(o && o.job && Date.now()-(o.t||0) < HALTEN) return o; if(o) localStorage.removeItem(KEY); }catch(e){}
    return null;
  };
  window.apJobWarten=function(job, fertig, opt){
    opt=opt||{};
    var erledigt=false, timer=null, unbekannt=0, t0=Date.now(), warWeg=(document.visibilityState==='hidden');
    function ende(d){
      if(erledigt) return; erledigt=true;
      if(timer){ clearTimeout(timer); timer=null; }
      document.removeEventListener('visibilitychange', sicht);
      window.removeEventListener('pageshow', sicht);
      window.removeEventListener('online', sicht);
      merke(null);
      try{ if(d && (warWeg || opt.rueckkehr) && window.apZaehl) window.apZaehl('rueckkehr'); }catch(e){}
      fertig(d);
    }
    function plane(ms){ if(erledigt) return; if(timer) clearTimeout(timer); timer=setTimeout(frage, ms); }
    function frage(){
      if(erledigt) return;
      if(timer){ clearTimeout(timer); timer=null; }
      if(Date.now()-t0 > 15*60*1000){ ende(null); return; }
      fetch(WK+'/job?id='+job, {cache:'no-store'})
        .then(function(r){ return r.json(); })
        .then(function(s){
          if(s && (s.status==='fertig' || s.status==='fehler')){ ende(s.antwort||{}); return; }
          if(s && s.status==='laeuft'){ unbekannt=0; plane(2500); return; }
          unbekannt++;
          if(unbekannt >= (opt.maxUnbekannt||4)){ ende(null); return; }
          plane(2500);
        })
        .catch(function(){ plane(document.visibilityState==='hidden'?6000:1500); });
    }
    function sicht(){ if(document.visibilityState==='hidden'){ warWeg=true; } else { frage(); } }
    document.addEventListener('visibilitychange', sicht);
    window.addEventListener('pageshow', sicht);
    window.addEventListener('online', sicht);
    plane(opt.ersteMs||3000);
  };
  window.apJobSenden=function(body, art, fertig, extra){
    var job=neueId(); body.job=job;
    var m={job:job, art:art, t:Date.now()}; if(extra){ for(var k in extra){ m[k]=extra[k]; } }
    merke(m);
    /* AP-UPLOAD-STABIL-2910: bei abgelehntem Sicherheits-Token einmal mit frischem Token nachsenden */
    function _apSende(){
      return (window.apTsToken?window.apTsToken():Promise.resolve('')).then(function(tk){
        body.tsToken=tk;
        return fetch(WK, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
      }).then(function(r){ return r.json(); });
    }
    _apSende()
    .then(function(d){ if(d && d.error==='bot'){ return new Promise(function(w){ setTimeout(w,1500); }).then(_apSende); } return d; })
    .then(function(d){
      if(d && d.job===job && d.status==='laeuft'){
        try{ if(window.apLadeHinweis2) window.apLadeHinweis2(); }catch(e){}
        window.apJobWarten(job, fertig); return;
      }
      merke(null);
      if(d && d.job===job && d.antwort){ fertig(d.antwort); return; }
      fertig(d);   /* alter Worker oder sofortige Antwort (Limit, Bot-Pruefung, Fehler) */
    })
    .catch(function(){
      /* Antwort verloren (App-Wechsel waehrend des Hochladens, Funkloch): der Job kann
         trotzdem angekommen sein -> nachfragen; "unbekannt" = wirklich nicht angekommen */
      window.apJobWarten(job, fertig, {ersteMs:1500, maxUnbekannt:4});
    });
    return job;
  };
})();
/* ── EINGEFROREN: Turnstile (apTsToken/apTsLoad) ──
   Herkunft: assets/arturell-product.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme 873031e3043d
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
if(!window.apTsToken){
/* ── TURNSTILE 19.07. (v2): ALLES an window, weil die Datei aus mehreren
   abgeschlossenen IIFEs besteht und lokale Funktionen dort unsichtbar sind. ── */
window.AP_TS_SITEKEY='0x4AAAAAAD5KX_2BV20P_wpV';
window._apTsId=null;window._apTsCb=null;
window.apTsLoad=function(){
  return new Promise(function(res){
    if(window.turnstile&&window.turnstile.render){res(true);return;}
    if(!document.getElementById('apTsScript')){
      var sc=document.createElement('script');sc.id='apTsScript';
      sc.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      sc.async=true;sc.defer=true;document.head.appendChild(sc);
    }
    var t0=Date.now();
    var iv=setInterval(function(){
      if(window.turnstile&&window.turnstile.render){clearInterval(iv);res(true);}
      else if(Date.now()-t0>10000){clearInterval(iv);res(false);}
    },100);
  });
};
window.apTsToken=function(){
  try{
    return window.apTsLoad().then(function(ok){
      if(!ok){console.log('Turnstile: Script nicht geladen');return '';}
      return new Promise(function(res){
        var fertig=false;
        function liefere(t){ if(!fertig){fertig=true;window._apTsCb=null;res(t||'');} }
        window._apTsCb=liefere;
        try{
          if(window._apTsId===null){
            var box=document.getElementById('apTsBox');
            if(!box){box=document.createElement('div');box.id='apTsBox';
              box.style.cssText='position:fixed;bottom:10px;right:10px;z-index:99999';
              document.body.appendChild(box);}
            window._apTsId=window.turnstile.render(box,{
              sitekey:window.AP_TS_SITEKEY,appearance:'interaction-only',execution:'execute',
              callback:function(t){ if(window._apTsCb)window._apTsCb(t); },
              'error-callback':function(){ if(window._apTsCb)window._apTsCb(''); },
              'expired-callback':function(){ if(window._apTsCb)window._apTsCb(''); }
            });
          } else { window.turnstile.reset(window._apTsId); }
          window.turnstile.execute(window._apTsId);
        }catch(e){ console.log('Turnstile Fehler:',e.message); liefere(''); return; }
        setTimeout(function(){ liefere(''); },25000); /* AP-UPLOAD-STABIL-2910 */
      });
    });
  }catch(e){ console.log('Turnstile Aussenfehler:',e.message); return Promise.resolve(''); }
};
try{ window.apTsLoad(); }catch(e){}
}
/* ── EINGEFROREN: Merge-Prompts APF_MERGE_PROMPTS ──
   Herkunft: assets/arturell-family.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme 334ce8cfe7b2
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
window.APF_MERGE_PROMPTS = window.APF_MERGE_PROMPTS || {
    '2_hoch':'Combine ALL people and ALL animals from the reference images into one unified family portrait photograph. Several reference images may show more than one person or animal - every single one of them belongs in the final image. Before composing, count every person and every animal across all reference images; the final image must contain exactly that many - never drop, add, duplicate, merge or swap anyone. Preserve EACH person\'s and each animal\'s exact facial identity, features and proportions. Place everyone close together, waist-up, as a loving pair or small group, heads at slightly different heights, nobody hidden behind another or cut off at the image edges; children and animals in front. Unify lighting across everyone: soft, warm, even, same direction. Vertical portrait composition, natural perspective, consistent skin tones, photorealistic. Neutral softly-lit studio background.',
    '3_hoch':'Combine ALL people and ALL animals from the reference images into one unified family portrait photograph. Several reference images may show more than one person or animal - every single one of them belongs in the final image. Before composing, count every person and every animal across all reference images; the final image must contain exactly that many - never drop, add, duplicate, merge or swap anyone. Preserve EACH person\'s and each animal\'s exact facial identity, features and proportions. Arrange everyone in a natural triangle composition (heads at different heights, not stacked), waist-up, standing close together as a family, nobody hidden behind another or cut off at the image edges; children and animals in front. Unify lighting across everyone: soft, warm, even, same direction. Vertical portrait composition, consistent perspective and skin tones, photorealistic. Neutral softly-lit background.',
    '4_quer':'Combine ALL people and ALL animals from the reference images into one unified family portrait photograph. Several reference images may show more than one person or animal - every single one of them belongs in the final image. Before composing, count every person and every animal across all reference images; the final image must contain exactly that many - never drop, add, duplicate, merge or swap anyone. Preserve EACH person\'s and each animal\'s exact facial identity, features and proportions. Arrange everyone side by side as one family group in overlapping triangles (varied head heights, nobody stacked directly above another), chest-up, close together, nobody hidden behind another or cut off at the image edges; children and animals in front. Unify lighting across everyone: soft, warm, even, same direction. Horizontal landscape composition, consistent perspective and skin tones, photorealistic. Neutral softly-lit background.'
  };

/* ── EINGEFROREN: Merge-Zusatz (apfNext) ──
   Herkunft: assets/arturell-family.js im Theme-Repo, Commit 6445428 2026-10-30 15:27:35 +0200
   Eingefroren am 31.10.2026 12:48 mit fasttrack/einfrieren.py, Pruefsumme bd665133edd7
   Aendert sich der grosse Shop, bleibt dieser Block wie er ist. ── */
window.APF_MERGE_ZUSATZ = window.APF_MERGE_ZUSATZ || ' Remove or replace any readable text, logos, brand names or prints on clothing with plain fabric in a matching color. No visible letters or words anywhere in the image. CRITICAL AGE LOCK: preserve each person\'s exact apparent age from their photo - keep all wrinkles, skin texture, age lines and age markers faithfully. Never de-age, rejuvenate, beautify or smooth anyone\'s face - and never make anyone look older either: do not deepen or add wrinkles beyond what each photo shows. CRITICAL EYE COLOUR LOCK: every person in this artwork keeps the EXACT eye colour from their own source photo. These colours differ from person to person. Look at each face separately and reproduce each individual eye colour precisely. NEVER unify, match, average or transfer eye colour between people, and never default anyone to brown or to blue.';

/* ═══ FAST TRACK KERN (31.10.2026) ═══
   Eine Seite: Fotos (1 bis 4) -> Stil -> Vorschau -> Kaufkasten.
   1 Foto = Einzel-Weg (Produkt dein-kunstwerk-leinwand / -gerahmt),
   2 bis 4 Fotos = Familien-Zusammenfuehrung (Produkt familien-kunstwerk).
   Netz: window.apJobSenden / apJobWarten / apTsToken / apDevId / apGrant
   (eingefroren in src/eingefroren/netz-bausteine.js, siehe Kopf der Datei).
   Daten (Preise, Varianten, Stile) kommen aus <script id="ftDaten">.
   D.sim = true -> Klick-Entwurf ohne Shop (kein Netz, Bilder eingebettet). */
(function(){
  'use strict';
  var root = document.getElementById('ft');
  if (!root || root.getAttribute('data-ft-init')) return;
  root.setAttribute('data-ft-init', '1');
  var D = {};
  try { D = JSON.parse(document.getElementById('ftDaten').textContent); } catch (e) { return; }
  var SIM = !!D.sim, TEMPO = SIM ? 10 : 1, MAXF = 4;
  /* AP-ZEHN-FOTOS-3110: Test mit mehreren Einzelfotos NUR auf dem DEV-Theme (oder im Klick-Entwurf): ?maxfotos=5 bis 14
     (AP-FT-MAXF14-3110: vorher bis 10; 14 = harte Obergrenze im Worker, MERGE_MAX_HART).
     LIVE und ohne Parameter bleibt MAXF = 4. Preis und Variante ab 5 Fotos wie 4 Fotos (nur Test). Worker braucht MERGE_MAX_BILDER >= MAXF. */
  try { var _mf = /[?&]maxfotos=(\d+)/.exec(location.search); if (_mf && (SIM || String(window.Shopify && Shopify.theme && Shopify.theme.id) === String(D.devTheme))) MAXF = Math.max(4, Math.min(14, parseInt(_mf[1], 10) || 4)); } catch (e) {}
  function mx(r, w){ if (MAXF !== 4) r = r.split('4').join(String(MAXF)); if (w) { for (var k in w) { if (Object.prototype.hasOwnProperty.call(w, k)) r = r.split('{' + k + '}').join(String(w[k])); } } return r; }
  /* AP-FT-EN-3110: Markt aus dem Wrapper (build.py setzt per Liquid data-markt de|en|us und data-root = routes.root_url).
     DE: TX leer, T() gibt den deutschen Text unveraendert zurueck. EN/US: Texte aus D.tx (Quelle src/texte-en.json). */
  var M = root.getAttribute('data-markt') || 'de'; if (M !== 'en' && M !== 'us') M = 'de';
  var PFX = String(root.getAttribute('data-root') || '/').replace(/\/+$/, '');
  var TX = (M !== 'de' && D.tx && D.tx[M]) || null;
  function T(s, w){ var r = (TX && TX[s] !== undefined) ? TX[s] : s; if (w) { for (var k in w) { if (Object.prototype.hasOwnProperty.call(w, k)) r = r.split('{' + k + '}').join(String(w[k])); } } return r; }
  function wmg(d, fb){ if (M === 'de') return (d && d.message) || fb; var e = d && d.error && D.tx && D.tx.mg && D.tx.mg[d.error]; return e || T(fb); }
  function bildM(u){ return (M === 'de' || !u) ? u : String(u).replace('/v28/de/', '/v28/' + M + '/').replace(/--de\.webp$/, '--' + M + '.webp'); }
  function stilNm(s){ return (M !== 'de' && s && s.nameEn) ? s.nameEn : (s && s.name); }
  if (M === 'us' && D.us) { D.preise = D.us.preise; D.vids = D.us.vids; }   /* US-Katalog (src/markt-us.json); Betraege kommen trotzdem aus D.shop */
  /* AP-ZEHN-A-0111: 5 bis 10 Fotos (Niklas 01.11.). Kunstwerk bleibt Variante '4 Motive' zum heutigen Preis (33 % gilt), der Mehrpreis ist eine
     EIGENE Warenkorb-Position: Produkt aufpreis-familienbild (SKU AP-AUFPREIS-5-7 / -8-10), Betrag und ID per Liquid aus Shopify (D.auf).
     Gibt es das Produkt nicht, bleibt MAXF = 4 (wie vorher). Eigenschaften: _ap_gruppe (beide Positionen), _ap_aufpreis = 1 (nur Aufpreis), Fotos/Photos (sichtbar). */
  var AUF = {};
  try { ((D.auf && D.auf.v) || []).forEach(function(x){ var k = x[1] === 'AP-AUFPREIS-5-7' ? '5-7' : (x[1] === 'AP-AUFPREIS-8-10' ? '8-10' : ''); if (k && x[0] && x[2] > 0) AUF[k] = { id:String(x[0]), betrag:x[2] / 100 }; }); } catch (e) {}
  var AUF_OK = !!(AUF['5-7'] && AUF['8-10']);
  /* Regel 0.21 (in 1 Minute aenderbar): Grenzen aus den Theme-Einstellungen (D.auf.c), Texte aus locales arturell.zehn (D.auf.t), Betraege aus dem Produkt.
     Hier nur Ersatzwerte, falls etwas fehlt. Die Namen der Liquid-Felder stehen in patches/0111-zehn-fotos/zehn_liquid.py. */
  var ZC = (function(){ var c = (D.auf && D.auf.c) || {}, g = c.gr || {}; function z(x, d){ x = parseInt(x, 10); return x > 0 ? x : d; }
    return { ab:z(c.ab, 5), s2:z(c.s2, 8), max:z(c.max, 10), pers:z(c.pers, 10), text:(c.text === 'B' ? 'B' : 'A'), gr:{ s:z(g.s, 4), m:z(g.m, 7), l:z(g.l, 10), xl:z(g.xl, 10) } }; })();
  try { var _at = /[?&]auftext=([AB])/.exec(location.search); if (_at && (SIM || String(window.Shopify && Shopify.theme && Shopify.theme.id) === String(D.devTheme))) ZC.text = _at[1]; } catch (e) {}
  /* AP-GESICHT-0111: Gesichts-Hinweis je Foto (Worker motivOnly + gesicht:true). Nur Hinweis, nie Sperre.
     Schalter Theme-Einstellung ap_gesicht_an -> D.auf.c.gs (true = an, Standard aus). DEV-Theme: ?gesicht=1 erzwingt an. Texte arturell.zehn.gs_* */
  var GS = (function(){ var c = (D.auf && D.auf.c) || {}, an = c.gs === true;
    try { if (D.devTheme && String(window.Shopify && Shopify.theme && Shopify.theme.id) === String(D.devTheme)) {   /* AP-GESICHT-FIX-0111: DEV-Schalter gilt fuer die ganze Sitzung (Mail-Freischaltung, Neuladen, Seitenwechsel) */
      var gq = /[?&]gesicht=([01])(&|$)/.exec(location.search);
      if (gq) { try { if (gq[1] === '1') sessionStorage.setItem('apGsDev', '1'); else sessionStorage.removeItem('apGsDev'); } catch (e2) {} }
      if (gq ? gq[1] === '1' : sessionStorage.getItem('apGsDev') === '1') an = true; } } catch (e) {}
    return { an:an, tippsAb:5, minPx:150, zoomMax:3 }; })();
  function gsKlein(f){ var g = f.gesicht; if (!g || !g.k) return false; return g.anteil * ((f.pos && f.pos.z) || 1) / (g.z0 || 1) < g.grenze; }
  function gsZoomHilft(f){ var g = f.gesicht, z0 = (g && g.z0) || 1; if (!g || g.n > 2) return false;
    return g.anteil * GS.zoomMax / z0 >= g.grenze && g.anteil * f.h / z0 >= GS.minPx; }
  function gsHinweis(f, fam, nr){
    var g = f.gesicht; if (!GS.an || !g || SIM || !tx('gs_trotzdem')) return null;
    var s = [], kurz = '', zoom = false, w = { n:nr };
    if (g.a && fam) { s.push(tx('gs_augen', w)); kurz = kurz || tx('gs_kurz_augen'); }
    if (g.u) { s.push(tx(g.b ? 'gs_unscharf_bildschirm' : 'gs_unscharf', w)); kurz = kurz || tx('gs_kurz_unscharf'); }
    else if (g.b) { s.push(tx('gs_bildschirm', w)); kurz = kurz || tx('gs_kurz_bildschirm'); }   /* Messung 01.11. 02:52: Bildschirmfoto erkannt 3/3, unscharf 0/3 */
    if (gsKlein(f)) {
      zoom = gsZoomHilft(f);
      s.push(tx(g.n > 2 ? 'gs_klein_gruppe' : (zoom ? 'gs_klein_zoom' : 'gs_klein_foto'), w));
      kurz = kurz || tx(g.n > 2 ? 'gs_kurz_gruppe' : 'gs_kurz_klein');
    }
    return s.length ? { kurz:kurz, saetze:s, zoom:zoom } : null;
  }
  function gsKlick(id){
    var i = -1; S.fotos.forEach(function(x, k){ if (x.id === id) i = k; }); var f = S.fotos[i]; if (!f || S.busy) return;
    var h = gsHinweis(f, S.fotos.length >= 2, i + 1); if (!h) return;
    if (h.zoom) { cropOeffnen(id); return; }   /* Zoom hilft: gleich das Ausschnitt-Fenster */
    box(tx('gs_titel', { n:i + 1 }), '<p>' + h.saetze.map(esc).join('</p><p>') + '</p><p>' + esc(tx('gs_trotzdem')) + '</p>');
  }
  function tx(k, w){ var t = (D.auf && D.auf.t) || {}, v = t[k + '_' + ZC.text.toLowerCase()]; if (v == null) v = t[k]; v = String(v == null ? '' : v);
    var b = { ab:ZC.ab, b1:ZC.s2 - 1, s2:ZC.s2, max:ZC.max, gs:ZC.gr.s, gm:ZC.gr.m, gl:ZC.gr.l }; if (w) { for (var x in w) { if (Object.prototype.hasOwnProperty.call(w, x)) b[x] = w[x]; } }
    return v.replace(/\{(\w+)\}/g, function(m, n){ return b[n] != null ? String(b[n]) : m; }); }
  if (AUF_OK && MAXF === 4) MAXF = ZC.max;   /* ?maxfotos (nur DEV) gewinnt */
  (function(){   /* AP-ZEHN-TEXT-0111: Upload-Text nennt die echte Hoechstzahl, ohne Aufpreis-Produkt bleibt der Text aus markup.html (4) */
    var up = document.getElementById('ftUpload'); if (!up || MAXF === 4) return;
    var w = { n:MAXF }, t1 = up.querySelector('.ft-up-t'), t2 = up.querySelector('.ft-up-x');
    up.setAttribute('aria-label', T('Fotos auswählen: 1 Foto oder bis zu {n}', w));
    if (t1) t1.textContent = T('1 Foto oder bis zu {n}', w);
    if (t2) t2.textContent = T('Ein Foto wird dein Kunstwerk. 2 bis {n} Fotos von Menschen oder Tieren setzen wir zu einem gemeinsamen Bild zusammen. Gruppenfotos sind herzlich willkommen.', w);
  })();
  function aufStufe(n){ return n >= ZC.s2 ? '8-10' : (n >= ZC.ab ? '5-7' : ''); }
  function aufFuer(w){ if (!AUF_OK || !w || w.modus !== 'familie') return null; var k = aufStufe(w.motive || 0); return k ? { st:k, id:AUF[k].id, betrag:AUF[k].betrag, txt:tx('stufe', k === '8-10' ? { von:ZC.s2, bis:ZC.max } : { von:ZC.ab, bis:ZC.s2 - 1 }) } : null; }
  function gruppeId(){ return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  /* Erklaertext: zwei Fassungen in locales (zeile_a/_b, reihe_a/_b, warum_a/_b), Wahl per Theme-Einstellung ap_zehn_text, DEV-Vorschau ?auftext=B */
  function aufWarum(){ return '<details class="ft-auf-mehr"><summary>' + esc(tx('warum_titel')) + '</summary><p>' + esc(tx('warum')) + '</p></details>'; }
  function aufZeile(au, p){ return tx('zeile', { s:euro(p + au.betrag), k:euro(p), z:euro(au.betrag), st:au.txt }); }
  function aufReihe(){ return tx('reihe', { a:euro(AUF['5-7'].betrag), b:euro(AUF['8-10'].betrag) }); }
  var SEK_GEN = 60, SEK_MERGE = 75;       /* gemessen 29.10.: 56,5 bis 59,4 s; Merge ~74 s (Kommentar arturell-family.js) */
  var MOTIV_OK = ['person','tier','paar','baby','gruppe'];
  var NUR_LEBEWESEN = ['aquarell-portrait','royal','dark-academia','action-figure','ceo','strickfigur','regenbogenbruecke','feuerwehr','pilot','koch','rockstar','boxer','wiesn','cowboy','general','gentleman'];
  var SPERREN = { tier:[], person:[], paar:[], gruppe:['action-figure'], baby:[],
    fahrzeug: NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']),
    ort:      NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']),
    gebaeude: NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']) };
  var GR = ['s','m','l','xl'];
  var CM = { s:[20,30], m:[40,60], l:[60,90], xl:[80,120] };
  var ZOLL = { s:[8,12], m:[16,24], l:[20,30], xl:[24,36] };   /* AP-FT-EN-3110: US in Zoll wie AP_ZOLL im Theme */
  var FARBEN = { black:T('Schwarz matt'), white:T('Galerieweiß'), wood:T('Eiche natur') };
  /* Stilnamen am Handy sauber trennen (weiches Trennzeichen an der Wortfuge statt Silbenraten) */
  var TRENN = { 'Regenbogenbrücke':'Regenbogen\u00ADbrücke', 'Sternenhimmel':'Sternen\u00ADhimmel', 'Sonnenstrahlen':'Sonnen\u00ADstrahlen',
                'Impressionismus':'Impressio\u00ADnismus', 'Gedenkkerze':'Gedenk\u00ADkerze', 'Chromaflare':'Chroma\u00ADflare' };
  var TRENN_RE = new RegExp(Object.keys(TRENN).join('|'), 'g');

  function $(s, c){ return (c || root).querySelector(s); }
  function $$(s, c){ return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function zahl(s){ return (s === null || s === undefined || s === '') ? null : parseFloat(String(s).replace(',', '.')); }
  function euro(n){ if (M === 'us') return '$' + n.toFixed(2); if (M === 'en') return '€' + n.toFixed(2); return n.toFixed(2).replace('.', ',') + ' €'; }
  function lsGet(k){ try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v){ try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }

  /* Overlays an body haengen (sonst begrenzen Theme-Container position:fixed) */
  ['ftLade','ftCrop','ftNl','ftBox'].forEach(function(id){
    var el = document.getElementById(id);
    if (el && el.parentElement !== document.body) { try { document.body.appendChild(el); } catch (e) {} }
  });
  function O(id){ return document.getElementById(id); }

  var S = { fotos:[], stil:'aquarell', stilName:T('Aquarell'), merged:null, mergedKey:'', mergedN:0, mergedFmt:'hoch',
            busy:false, werke:[], aktiv:-1, mat:'canvas', farbe:'black', gr:'m', mehr:false, kaufLaeuft:false,
            phase:'start', fotoKlein:null, fotoKleinFmt:'hoch', fotoKleinKey:'' };
  var naechsteId = 1;

  /* ── Modus und Format ── */
  function modus(){ return S.fotos.length >= 2 ? 'familie' : 'einzel'; }
  function fmtEinzel(f){ return (f && f.w / f.h >= 1) ? 'quer' : 'hoch'; }
  /* Familie: Empfehlung wie fmtEmpfehlung der Familienseite (2 und 3 hoch, 4 quer); der Kunde kann umstellen.
     Die Wahl gilt nur fuer die Fotoanzahl, bei der sie getroffen wurde. Einzel: Format folgt dem Foto. */
  /* AP-FT-GRUPPE-QUER-3110: 4 Fotos ODER mind. ein Querformat-Foto (meist Gruppenfoto, viele Personen) -> quer empfohlen */
  function famEmpf(n){ if (n >= 4) return 'quer'; var pq = personenSumme(); if (pq !== null && pq >= GRUPPE_QUER) return 'quer'; for (var i = 0; i < S.fotos.length; i++){ var f = S.fotos[i]; if (f && f.w && f.h && f.w / f.h >= 1.2) return 'quer'; } return 'hoch'; }
  function famFmt(){ var n = S.fotos.length, w = S.famFmtWahl; return (w && w.n === n) ? w.fmt : famEmpf(n); }
  /* AP-GRUPPE-3110: Personen je Foto (motivPruefen, Worker zaehlt bei zaehlen:true). Teilsumme = Untergrenze.
     Nur Familie (2 bis 4 Fotos): ab 6 quer empfohlen, 13 bis 20 Hinweis, ueber 20 gesperrt (Befund 31.10.2026).
     1 Foto (Einzel-Weg, Messung 31.10. 18:08: 29 Personen alle drauf): keine Sperre, ueber 20 nur sanfter Hinweis.
     Solange keine Zahl da ist: alles wie bisher. */
  var GRUPPE_QUER = 6, GRUPPE_HINWEIS = 13, GRUPPE_MAX = ZC.pers;   /* AP-ZEHN-A-0111: hoechstens ZC.pers (Theme-Einstellung, 10 nach E135/E138), vorher 20; Hinweis ab 13 greift damit nicht mehr */
  function persMax(){ return tx('max_pers', { n:GRUPPE_MAX }) || T('Höchstens 10 Personen pro Kunstwerk. Bitte ein Foto entfernen.'); }
  /* AP-ZEHN-A-0111: Koepfe = Personen + Tiere (Worker-Zaehlung), mindestens 1 je Foto. Groessen-Grenzen ZC.gr aus den Theme-Einstellungen (E138: S 4, M 7, L/XL 10). */
  var GR_KOEPFE = ZC.gr;
  function koepfeFotos(){ var k = 0; S.fotos.forEach(function(f){ var p = (typeof f.personen === 'number' ? f.personen : 0) + (typeof f.tiere === 'number' ? f.tiere : 0); k += Math.max(1, p); }); return k; }
  function koepfe(w){ if (!w || w.modus !== 'familie') return 0; var k = Math.max(w.motive || 0, w.koepfe || 0); if (S.fotos.length >= 2 && S.fotos.length === w.motive) k = Math.max(k, koepfeFotos()); return k; }
  function grGesperrt(w, gr){ var k = koepfe(w); return k > 0 && k > (GR_KOEPFE[gr] || 99); }
  function grAusweich(w, mat, alt){   /* AP-ZEHN-A-0111-RAHMEN: erlaubte Groesse mit Preis, zuerst kleiner (wie bisher M), dann groesser; keine -> null */
    var i = GR.indexOf(alt), r = [], a;
    for (a = i - 1; a >= 0; a--) r.push(GR[a]);
    for (a = i + 1; a < GR.length; a++) r.push(GR[a]);
    for (a = 0; a < r.length; a++) { if (!grGesperrt(w, r[a]) && preisFuer(w, mat, r[a]) !== null) return r[a]; }
    return null;
  }
  function personenSumme(){ var p = 0, da = false; S.fotos.forEach(function(f){ if (typeof f.personen === 'number') { p += f.personen; da = true; } }); return da ? p : null; }
  function fotoIds(){ return S.fotos.map(function(f){ return f.id; }).join(','); }
  function gruppeStand(){
    var n = S.fotos.length, p = personenSumme();
    if (n === 1) return (p !== null && p > GRUPPE_MAX) ? 'einzelviele' : '';
    if (n < 2) return '';
    if (S.gruppeServer && S.gruppeServer === fotoIds()) return 'sperre';   /* Worker meldete zu_viele_personen fuer genau diese Fotos */
    if (p === null) return '';
    if (p > GRUPPE_MAX) return 'sperre';
    if (p >= GRUPPE_HINWEIS) return 'pruefen';
    return '';
  }
  function gruppeGesperrt(){ return gruppeStand() === 'sperre'; }
  /* AP-FT-ORIGINAL-3110: Kachel "Original · Fotoporträt" = fertiges Zusammenfuehrungsbild (S.merged, previewsafe_), nur Familie,
     wie apOriginalWaehlen der Familienseite. Keine neue Erzeugung, kein Kontingent. Fulfillment tauscht previewsafe_ -> preview_. */
  var ORIG_NAME = T('Original · Fotoporträt');
  function origDa(){
    if (!S.merged || !/^https?:\/\//.test(String(S.merged))) return false;
    if (S.fotos.length >= 2) return S.mergedKey === quelleKey();
    if (!S.fotos.length) { var w = S.werke[S.aktiv]; return !!(w && w.modus === 'familie'); }
    return false;
  }
  function origZeigen(){
    if (!S.merged) return;
    var quelle = 'm:' + S.merged, i = -1;
    S.stil = 'original'; S.stilName = ORIG_NAME;
    for (var k = 0; k < S.werke.length; k++) { if (S.werke[k].quelle === quelle && S.werke[k].stil === 'original') { i = k; break; } }
    if (i < 0) { S.werke.push({ url:S.merged, stil:'original', stilName:ORIG_NAME, modus:'familie', motive:S.mergedN || S.fotos.length || 2, koepfe:koepfeFotos(), fmt:S.mergedFmt, quelle:quelle }); i = S.werke.length - 1; }
    S.aktiv = i; S.busy = false; S.phase = 'vorschau';
    if (S.mat === 'framed_canvas' && preisFuer(S.werke[S.aktiv], 'framed_canvas', S.gr) === null) S.gr = 'm';
    speichern(); ladeAus(); renderAlles(); nachOben(); zaehl('vorschau');
  }
  function fmtJetzt(){ return modus() === 'familie' ? famFmt() : fmtEinzel(S.fotos[0]); }
  /* AP-FT-GANZES-FOTO-3110: Familien-Modus nutzt das ganze Foto (eigenes Seitenverhaeltnis) fuer Zaehlung, Ausschnitt und Merge;
     vorher fest 2:3 hochkant (Quer-Gruppenfotos verloren Personen am Rand). Einzel unveraendert. */
  function fotoRatio(f){ return (f && f.w && f.h) ? f.w / f.h : 2/3; }
  function ratioFoto(f){ return modus() === 'familie' ? fotoRatio(f) : (fmtEinzel(f) === 'quer' ? 3/2 : 2/3); }
  function quelleKey(){ return S.fotos.map(function(f){ return f.id + ':' + f.pos.x.toFixed(3) + ',' + f.pos.y.toFixed(3) + ',' + f.pos.z.toFixed(2); }).join('|') + (modus() === 'familie' ? '|' + famFmt() : ''); }

  /* ── Aktion (gleiche Fenster wie AP-AKTION-33-3010) ── */
  function aktionAn(){
    if (SIM) return true;
    var t = Date.now(), an = D.aktion && D.aktion.an, aus = D.aktion && D.aktion.aus;
    var dev = false;
    try { dev = String(window.Shopify && Shopify.theme && Shopify.theme.id) === String(D.devTheme) && /[?&]ap_aktion=1/.test(location.search); } catch (e) {}
    return (t >= an && t <= aus) || dev;
  }

  /* ── Lieferdatum (Algorithmus wie AP-LIEFERDATUM-3010, DE: 4 bis 7 Werktage) ── */
  function lieferText(){
    var ft = M === 'us' ? ['2026-11-26','2026-12-25','2027-01-01','2027-01-18','2027-02-15','2027-05-31','2027-07-05','2027-09-06'] : ['2026-12-25','2026-12-26','2027-01-01','2027-03-26','2027-03-29','2027-05-01','2027-05-06','2027-05-17','2027-10-03'];
    function iso(d){ return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function plus(n){ var d = new Date(); d.setHours(12,0,0,0); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w > 0 && w < 6 && ft.indexOf(iso(d)) < 0) c++; } return d; }
    var tde = ['So','Mo','Di','Mi','Do','Fr','Sa'];
    function fde(d){ return tde[d.getDay()] + ' ' + ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.'; }
    if (M === 'de') return 'Lieferung voraussichtlich ' + fde(plus(4)) + ' bis ' + fde(plus(7));
    /* AP-FT-EN-3110: wie AP-LIEFERDATUM-3010 im Theme (EN 4 bis 7, US 4 bis 8 Werktage, US-Feiertage) */
    var ten = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], men = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function fen(d){ return M === 'us' ? (ten[d.getDay()] + ', ' + men[d.getMonth()] + ' ' + d.getDate()) : (ten[d.getDay()] + ' ' + d.getDate() + ' ' + men[d.getMonth()]); }
    return 'Estimated delivery: ' + fen(plus(4)) + ' to ' + fen(plus(M === 'us' ? 8 : 7));
  }

  /* ── Meldungen ── */
  var toastT = null;
  function toast(msg){
    var t = O('ftToast');
    if (!t) { t = document.createElement('div'); t.id = 'ftToast'; t.className = 'ft-toast'; t.setAttribute('role','status'); document.body.appendChild(t); }
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function(){ t.hidden = true; }, 4200);
  }
  function box(titel, html, knopf){
    var b = O('ftBox'); if (!b) { alert(titel); return; }
    $('.ft-box-t', b).textContent = titel;
    $('.ft-box-txt', b).innerHTML = html || '';
    $('.ft-box-ok', b).textContent = knopf || T('Verstanden');
    b.hidden = false;
  }
  function boxZu(){ var b = O('ftBox'); if (b) b.hidden = true; }

  /* ── Bilder: Zuschnitt aus dem Original (Mitte, verschiebbar im Ausschnitt-Fenster) ── */
  function fenster(f, ratio, pos){
    pos = pos || f.pos;
    var z = pos.z || 1;
    var bw = Math.min(f.w, f.h * ratio) / z, bh = bw / ratio;
    var cx = Math.min(Math.max(pos.x * f.w, bw / 2), f.w - bw / 2);
    var cy = Math.min(Math.max(pos.y * f.h, bh / 2), f.h - bh / 2);
    return { x: cx - bw / 2, y: cy - bh / 2, w: bw, h: bh };
  }
  function zuschnitt(f, ratio, maxL, q){
    var r = fenster(f, ratio), k = Math.min(1, maxL / Math.max(r.w, r.h));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(r.w * k)); c.height = Math.max(1, Math.round(r.h * k));
    c.getContext('2d').drawImage(f.img, r.x, r.y, r.w, r.h, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', q || 0.9);
  }

  /* ── Upload ── */
  var input = $('#ftFile');
  function waehlen(){ if (S.busy) return; if (S.fotos.length >= MAXF) { toast(mx(T('Es sind schon 4 Fotos drin. Entferne eins, um ein anderes zu nehmen.'))); return; } if (input) { input.value = ''; input.click(); } }
  function dateien(list){
    var files = Array.prototype.slice.call(list || []).filter(function(f){ return f && (/^image\//.test(f.type || '') || /\.(heic|heif|jpe?g|png|webp)$/i.test(f.name || '')); });
    if (!files.length) return;
    var frei = MAXF - S.fotos.length;
    if (frei <= 0) { toast(mx(T('Höchstens 4 Fotos pro Kunstwerk.'))); return; }
    if (files.length > frei) { toast(mx(T('Höchstens 4 Fotos pro Kunstwerk. Wir haben die ersten {n} übernommen.'), { n:frei })); files = files.slice(0, frei); }
    files.forEach(function(file){
      if (file.size > 20 * 1024 * 1024) { toast(T('Bitte Fotos unter 20 MB wählen.')); return; }
      var fix = window.apHeicFix ? window.apHeicFix(file) : Promise.resolve(file);
      fix.then(function(f2){ if (f2) lesen(f2); });
    });
  }
  function lesen(file){
    var r = new FileReader();
    r.onload = function(ev){ ladeBild(ev.target.result, file, {}); };
    r.onerror = function(){ toast(T('Dieses Foto konnte nicht gelesen werden. Bitte wähle ein JPG oder PNG.')); };
    r.readAsDataURL(file);
  }
  function ladeBild(src, file, extra){
    var img = new Image(), zweiter = false;
    img.onload = function(){
      if (S.fotos.length >= MAXF) { if (extra.danach) extra.danach(); return; }
      var f = { id: naechsteId++, img: img, w: img.naturalWidth, h: img.naturalHeight, pos: { x:.5, y:.5, z:1 }, motiv: extra.motiv || null };
      var g = extra.gemerkt;   /* AP-FT-FOTOS-BEHALTEN-3110 */
      if (g) {
        if (typeof g.id === 'number') { f.id = g.id; naechsteId = Math.max(naechsteId, g.id + 1); }
        if (g.pos) f.pos = { x:+g.pos.x || .5, y:+g.pos.y || .5, z:+g.pos.z || 1 };
        f.motiv = g.motiv || null;
        if (typeof g.personen === 'number') f.personen = g.personen;
        if (typeof g.tiere === 'number') f.tiere = g.tiere;
        if (g.gesicht && typeof g.gesicht.anteil === 'number') f.gesicht = g.gesicht;   /* AP-GESICHT-0111 */
        if (g.gp) f.gp = 1;   /* AP-GESICHT-FIX-0111: Gesicht war schon geprueft */
      }
      S.fotos.push(f);
      S.phase = 'fotos';
      renderAlles();
      if (!g || !f.motiv || typeof f.personen !== 'number' || (GS.an && !f.gp && !f.gesicht)) motivPruefen(f);   /* AP-GESICHT-FIX-0111: ohne Gesichts-Ergebnis neu pruefen */
      if (extra.danach) extra.danach();
    };
    img.onerror = function(){
      /* wie AP-UPLOAD-DECODE-2910: zweiter Versuch ueber Objekt-URL + Verkleinern */
      if (!zweiter && file && window.URL && URL.createObjectURL) {
        zweiter = true;
        try {
          var u = URL.createObjectURL(file), i2 = new Image();
          i2.onload = function(){
            try {
              var k = Math.min(1, 4000 / Math.max(i2.naturalWidth, i2.naturalHeight));
              var c = document.createElement('canvas'); c.width = Math.round(i2.naturalWidth * k); c.height = Math.round(i2.naturalHeight * k);
              c.getContext('2d').drawImage(i2, 0, 0, c.width, c.height); URL.revokeObjectURL(u);
              img.src = c.toDataURL('image/jpeg', 0.92);
            } catch (e) { URL.revokeObjectURL(u); toast(T('Dieses Bildformat wird nicht unterstützt. Bitte wähle ein JPG oder PNG.')); }
          };
          i2.onerror = function(){ URL.revokeObjectURL(u); toast(T('Dieses Bildformat wird nicht unterstützt. Bitte wähle ein JPG oder PNG.')); };
          i2.src = u; return;
        } catch (e) {}
      }
      toast(T('Dieses Bildformat wird nicht unterstützt. Bitte wähle ein JPG oder PNG.'));
      if (extra.danach) extra.danach();   /* AP-FT-FOTOS-BEHALTEN-3110: Kette nicht abbrechen */
    };
    img.src = src;
  }
  function entfernen(id){
    if (S.busy) return;
    S.fotos = S.fotos.filter(function(f){ return f.id !== id; });
    if (!S.fotos.length && !S.werke.length) S.phase = 'start';
    renderAlles();
  }

  /* Motiv-Erkennung (gleicher Aufruf wie apfMotivCheck / Einzel-Upload: motivOnly) */
  function motivPruefen(f){
    if (SIM) { f.motiv = f.motiv || 'person'; renderStile(); return; }
    var bild; try { bild = zuschnitt(f, fotoRatio(f), 1600, 0.85); } catch (e) { return; }   /* AP-FT-GANZES-FOTO-3110: ganzes Foto, 1600 px */
    var gsZ0 = (f.pos && f.pos.z) || 1;   /* AP-GESICHT-0111: Zoom beim Messen */
    fetch(D.worker, { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ image: bild, stil:'aquarell', format:'hoch', motivOnly:true, zaehlen:true, gesicht:(GS.an || undefined) }) })   /* AP-GRUPPE-3110 + AP-GESICHT-0111: gesicht nur wenn an */
      .then(function(r){ return r.json(); })
      .then(function(d){
        f.motiv = (d && d.motiv) || 'person';
        if (d && typeof d.personen === 'number' && d.personen >= 0) { f.personen = d.personen; f.tiere = (typeof d.tiere === 'number') ? d.tiere : 0; }   /* AP-GRUPPE-3110 */
        if (GS.an && d && d.gesicht && typeof d.gesicht.anteil === 'number' && typeof d.gesicht.grenze === 'number') { var gz = d.gesicht;   /* AP-GESICHT-0111 */
          f.gesicht = { k:!!gz.klein, a:!!gz.augen_verdeckt, u:!!gz.unscharf, b:!!gz.bildschirm, n:(gz.n || 1), anteil:gz.anteil, grenze:gz.grenze, z0:gsZ0 }; }
        if (GS.an && d && d.ok) f.gp = 1;   /* AP-GESICHT-FIX-0111: geprueft (auch wenn kein Gesicht zurueckkam) */
        if (S.fotos.length >= 2 && MOTIV_OK.indexOf(f.motiv) < 0) {
          var lab = { fahrzeug:T('ein Fahrzeug'), ort:T('einen Ort'), gebaeude:T('ein Gebäude') }[f.motiv] || T('kein passendes Motiv');
          S.fotos = S.fotos.filter(function(x){ return x !== f; });
          renderAlles();
          box(T('Dieses Foto passt nicht'), '<p>' + T('Das Foto zeigt {x}. Für ein gemeinsames Bild brauchen wir Fotos von Personen oder Tieren.', { x:esc(lab) }) + '</p>');
          return;
        }
        if (S.fotos.indexOf(f) > -1) renderFotos();   /* AP-GRUPPE-3110: Format-Empfehlung und Hinweis nach Personen */
        renderStile(); knoepfe();
      })
      .catch(function(){});
  }

  /* ── Ausschnitt-Fenster ── */
  var CR = { f:null, pos:null, ratio:2/3, cw:0, ch:0, drag:false, lx:0, ly:0 };
  function cropOeffnen(id){
    var f = S.fotos.filter(function(x){ return x.id === id; })[0]; if (!f || S.busy) return;
    var m = O('ftCrop'); if (!m) return;
    CR.f = f; CR.pos = { x:f.pos.x, y:f.pos.y, z:f.pos.z }; CR.ratio = ratioFoto(f);
    m.hidden = false;
    var stage = $('.ft-crop-stage', m), cv = $('canvas', m);
    var maxW = stage.clientWidth || 360, maxH = Math.round((window.innerHeight || 700) * 0.55);
    var cw = maxW, ch = Math.round(maxW / CR.ratio);
    if (ch > maxH) { ch = maxH; cw = Math.round(maxH * CR.ratio); }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(cw * dpr); cv.height = Math.round(ch * dpr); cv.style.width = cw + 'px'; cv.style.height = ch + 'px';
    CR.cw = cw; CR.ch = ch; CR.dpr = dpr;
    $('.ft-zoom', m).value = Math.round(CR.pos.z * 100);
    cropZeichnen();
  }
  function cropZeichnen(){
    var m = O('ftCrop'), cv = $('canvas', m), ctx = cv.getContext('2d'), r = fenster(CR.f, CR.ratio, CR.pos);
    CR.pos.x = (r.x + r.w / 2) / CR.f.w; CR.pos.y = (r.y + r.h / 2) / CR.f.h;
    ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.drawImage(CR.f.img, r.x, r.y, r.w, r.h, 0, 0, cv.width, cv.height);
  }
  function cropPunkt(e){ var t = e.touches ? e.touches[0] : e; return { x:t.clientX, y:t.clientY }; }
  (function(){
    var m = O('ftCrop'); if (!m) return;
    var cv = $('canvas', m);
    function down(e){ CR.drag = true; var p = cropPunkt(e); CR.lx = p.x; CR.ly = p.y; e.preventDefault(); }
    function move(e){
      if (!CR.drag || !CR.f) return;
      var p = cropPunkt(e), r = fenster(CR.f, CR.ratio, CR.pos), k = r.w / CR.cw;
      CR.pos.x -= (p.x - CR.lx) * k / CR.f.w; CR.pos.y -= (p.y - CR.ly) * k / CR.f.h;
      CR.lx = p.x; CR.ly = p.y; cropZeichnen(); e.preventDefault();
    }
    function up(){ CR.drag = false; }
    cv.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    cv.addEventListener('touchstart', down, { passive:false }); cv.addEventListener('touchmove', move, { passive:false }); cv.addEventListener('touchend', up);
    $('.ft-zoom', m).addEventListener('input', function(){ CR.pos.z = Math.max(1, parseInt(this.value, 10) / 100); cropZeichnen(); });
    $('.ft-crop-ok', m).addEventListener('click', function(){ if (CR.f) { CR.f.pos = CR.pos; } m.hidden = true; CR.f = null; renderAlles(); });
    $('.ft-box-x', m).addEventListener('click', function(){ m.hidden = true; CR.f = null; });
  })();

  /* ── Lade-Overlay mit ehrlicher Restzeit ── */
  /* AP-FT-FORTSCHRITT-3110: erwartete Dauer aus den Messungen vom 31.10. (Klick bis Bild):
     1 Foto 56 bis 60 s; Familie 2 Fotos/18 Personen ~180 s, 10 Fotos/10 Personen 212 s, 3 Fotos/20 Personen 216 bis 318 s.
     Familie (Zusammenfuehrung + Bild): 120 s + 6 s je Foto + 6 s je Person (Personen unbekannt = Anzahl Fotos), hoechstens 480 s.
     Nur Bild: Einzel 75 s, Familie mit fertiger Zusammenfuehrung 90 s. Bewusst eher zu lang geschaetzt.
     Balken: bis zur erwarteten Dauer linear auf 90 %, danach langsam weiter Richtung 99,4 % (Zeitkonstante 120 s): nie Stillstand, nie 100 % vor dem Bild.
     Restzeit nur als Spanne in Minuten. Jeder Lauf wird gemessen: ftStand().dauer_s / .dauer, console.info('[FT-DAUER]'), localStorage ftDauerLog (letzte 30). */
  var L = { t0:0, sek:60, iv:null, merge:false, an:false, f:0, pers:null, p:0, w0:0, z:'' }, LETZTE_DAUER = null, LADE_TAU = 120;
  function erwartetSek(art, n){
    var f = S.fotos.length || n || 0, p = personenSumme();
    if (art !== 'merge') return (f >= 2 || (!S.fotos.length && S.merged && !S.fotoKlein)) ? 90 : 75;
    f = Math.max(2, f || S.mergedN || 2); p = Math.max(f, p === null ? f : p);
    return Math.min(480, 120 + 2 * f + 5 * p);   /* AP-ZEHN-A-0111: vorher 120 + 6 * (f + p) = 240 s bei 10/10, gemessen 145 bis 212 s */
  }
  function spanne(sek){ var a = Math.max(1, Math.round(sek * 0.85 / 60)); return { a:a, b:Math.max(a + 1, Math.ceil(sek / 60)) }; }
  function ladeAn(art, start, n){
    var o = O('ftLade'); if (!o) return;
    L.merge = (art === 'merge');
    L.sek = erwartetSek(art, n);
    L.t0 = (start && start <= Date.now() && Date.now() - start < 20 * 60 * 1000) ? start : Date.now();   /* Wiederaufnahme: ab Absenden des Auftrags */
    L.an = true; L.f = S.fotos.length || n || S.mergedN || 1; L.pers = personenSumme(); L.w0 = S.werke.length; L.p = 0; L.z = '';
    var fotos = $('.ft-lade-fotos', o); fotos.innerHTML = '';
    fotos.classList.toggle('viele', S.fotos.length > 4);   /* AP-ZEHN-A-0111: alle Fotos zeigen, vorher nur 4 */
    S.fotos.slice(0, MAXF).forEach(function(f){ var i = document.createElement('img'); i.alt = ''; try { i.src = zuschnitt(f, 2/3, 200, 0.8); } catch (e) {} fotos.appendChild(i); });
    $('.ft-lade-t', o).textContent = L.merge ? T('Eure Fotos werden zusammengeführt') : T('Dein Kunstwerk entsteht');
    var lh = $('.ft-lade-h', o); lh.classList.remove('ok'); lh.textContent = T('Bitte bleib hier, bis deine Fotos hochgeladen sind.');   /* AP-FT-OPTIK-3110 */
    o.hidden = false;
    clearInterval(L.iv); L.iv = setInterval(ladeTick, 300); ladeTick();
  }
  function ladeZweiteStufe(){
    var o = O('ftLade'); if (!o || o.hidden) return;
    $('.ft-lade-t', o).textContent = T('Dein Kunstwerk entsteht');
  }
  function ladeProzent(t){ var E = L.sek; return t < E ? 90 * t / E : 90 + 9.4 * (1 - Math.exp(-(t - E) / LADE_TAU)); }
  function ladeTick(){
    var o = O('ftLade'); if (!o) return;
    var t = Math.max(0, (Date.now() - L.t0) / 1000 * TEMPO), E = L.sek, p = ladeProzent(t);
    L.p = p;
    $('.ft-lade-f', o).style.width = p.toFixed(2) + '%';
    $('.ft-lade-pz span', o).textContent = Math.min(99, Math.floor(p));
    var rest = E - t, z, viele = L.merge && (L.f >= 5 || (L.pers !== null && L.pers >= 6));
    if (rest > 0) { var m = rest / 60, a = Math.max(1, Math.floor(m)); z = T('noch etwa {a} bis {b} Minuten', { a:a, b:Math.max(a + 1, Math.ceil(m + 0.5)) }); }
    else if (-rest < 180) z = viele ? T('Bei vielen Personen braucht der Feinschliff etwas länger. Dein Bild kommt gleich.') : T('Der Feinschliff braucht etwas länger. Dein Bild kommt gleich.');
    else z = T('Heute dauert es etwas länger als sonst. Lass die Seite einfach offen, dein Bild erscheint hier.');
    L.z = z;
    var ze = $('.ft-lade-z', o); if (ze.textContent !== z) ze.textContent = z;
  }
  function ladeAus(){
    clearInterval(L.iv); var o = O('ftLade'); if (o) o.hidden = true;
    if (!L.an) return;
    L.an = false;
    var ende = Date.now(), d = { art:L.merge ? 'merge' : 'gen', ergebnis:S.werke.length > L.w0 ? 'bild' : 'abbruch', fotos:L.f, personen:L.pers,
      erwartet_s:L.sek, dauer_s:Math.round((ende - L.t0) / 100) / 10, prozent_ende:Math.round(L.p * 10) / 10,
      start:new Date(L.t0).toISOString(), ende:new Date(ende).toISOString(), markt:M, sim:SIM };
    LETZTE_DAUER = d;
    try { console.info('[FT-DAUER]', JSON.stringify(d)); } catch (e) {}
    if (!SIM) { try { var log = JSON.parse(lsGet('ftDauerLog') || '[]'); if (!Array.isArray(log)) log = []; log.push(d); lsSet('ftDauerLog', JSON.stringify(log.slice(-30))); } catch (e) {} }
  }
  /* wird von apJobSenden aufgerufen, sobald der Worker "laeuft" bestaetigt (Upload fertig) */
  window.apLadeHinweis2 = function(){
    var o = O('ftLade'); if (!o) return;
    var lh = $('.ft-lade-h', o); lh.innerHTML = '<b>' + T('Deine Fotos sind angekommen.') + '</b> ' + T('Du kannst kurz etwas anderes machen, dein Bild wartet hier auf dich.'); lh.classList.add('ok');   /* AP-FT-OPTIK-3110: Haken statt Hochladen, Stand fett */
  };

  /* ── Vorschau erstellen ── */
  function blockiert(){
    if (SIM || modus() !== 'familie') return '';   /* Entwurf: Beispielfotos sind bewusst klein eingebettet */
    var klein = S.fotos.filter(function(f){ return Math.max(f.w, f.h) < 600; });
    if (klein.length) return T('Mindestens ein Foto ist zu klein (unter 600 Pixel). Nimm bitte das Original aus deiner Galerie.');
    return '';
  }
  function starten(){
    if (S.busy) return;
    if (!S.fotos.length) {
      if (S.werke.length && S.fotoKlein) { gen(); return; }
      if (S.werke.length && S.merged) { gen(); return; }
      waehlen(); return;
    }
    var b = blockiert(); if (b) { box(T('Foto zu klein'), '<p>' + esc(b) + '</p>'); return; }
    if (modus() === 'familie' && gruppeGesperrt()) { box(T('Zu viele Personen'), '<p>' + persMax() + '</p>'); return; }   /* AP-GRUPPE-3110 */
    if (stilGesperrt(S.stil)) { toast(T('Dieser Stil passt nicht zu deinem Motiv. Bitte wähle einen anderen.')); return; }
    /* AP-ZEHN-A-0111: ab 5 Fotos erst die E-Mail-Bestaetigung (bestehendes Fenster), Worker zaehlt dort 1 Zusammenfuehrung + 1 Stil */
    if (modus() === 'familie' && AUF_OK && S.fotos.length >= ZC.ab && !(window.apGrant && window.apGrant()) && !SIM) { nlAuf(tx('mail')); zaehl('mailgate_5'); return; }
    if (modus() === 'familie') {
      if (S.merged && S.mergedKey === quelleKey()) gen(); else merge();
    } else {
      var f = S.fotos[0];
      S.fotoKlein = zuschnitt(f, ratioFoto(f), 800, 0.85);
      S.fotoKleinFmt = fmtEinzel(f); S.fotoKleinKey = quelleKey();
      gen();
    }
  }
  function merge(){
    var n = S.fotos.length, fmt = fmtJetzt(), key = quelleKey();
    var images = S.fotos.map(function(f){ return zuschnitt(f, ratioFoto(f), 3000, 0.9); });   /* AP-FT-GANZES-FOTO-3110: ganzes Foto statt 2:3 */
    var gesamt = 0; images.forEach(function(x){ gesamt += x.length; });
    if (gesamt > 90 * 1024 * 1024) { box(T('Fotos zu groß'), '<p>' + T('Deine Fotos sind zusammen zu groß für die Zusammenführung. Bitte verwende etwas kleinere Fotos (oder weniger).') + '</p>'); return; }
    S.busy = true; knoepfe(); ladeAn('merge');
    var fertig = function(d){
      if (d === null) { netzfehler(); return; }
      if (d && d.ok && d.safeUrl) {
        S.merged = d.safeUrl; S.mergedKey = key; S.mergedN = n; S.mergedFmt = fmt;
        speichern(); ladeZweiteStufe(); S.busy = false; gen(true); return;
      }
      fehler(d, 'merge');
    };
    if (SIM) { setTimeout(function(){ fertig({ ok:true, safeUrl:'sim-merge-' + key }); }, SEK_MERGE * 1000 / TEMPO); return; }
    var P = window.APF_MERGE_PROMPTS || {};
    var prompt = P[n + '_' + fmt];
    if (!prompt) {   /* Format gegen die Empfehlung: Prompt der Anzahl nehmen, nur den Bildaufbau-Satz tauschen */
      var basis = P[n + '_hoch'] || P[n + '_quer'] || (n > 4 ? P['4_quer'] : null) || P['3_hoch'];   /* AP-ZEHN-FOTOS-3110: ab 5 Fotos Aufbau wie 4 */
      prompt = fmt === 'quer' ? basis.replace('Vertical portrait composition', 'Horizontal landscape composition')
                              : basis.replace('Horizontal landscape composition', 'Vertical portrait composition');
    }
    prompt += window.APF_MERGE_ZUSATZ || '';
    window.apJobSenden({ familyMerge:true, images:images, format:fmt, mergePrompt:prompt,
      dev:(window.apDevId ? window.apDevId() : ''), grant:(window.apGrant ? window.apGrant() : '') },
      'merge', fertig, { format:fmt, seite:'ft', motive:n, stil:S.stil, stilName:S.stilName });
  }
  function gen(weiter){
    var fam = !!(S.fotos.length >= 2 || (!S.fotos.length && S.merged && !S.fotoKlein));
    if (S.stil === 'original') { if (fam && S.merged) { origZeigen(); return; } S.stil = 'aquarell'; S.stilName = T('Aquarell'); }   /* AP-FT-ORIGINAL-3110 */
    var quelle, body, fmt, n;
    if (fam) {
      if (!S.merged) { merge(); return; }
      fmt = S.mergedFmt; n = S.mergedN; quelle = 'm:' + S.merged;
      body = { image:S.merged, stil:S.stil, format:fmt, forceMotiv:'gruppe', dev:(window.apDevId ? window.apDevId() : ''), grant:(window.apGrant ? window.apGrant() : '') };
    } else {
      if (!S.fotoKlein) { toast(T('Bitte lade zuerst ein Foto hoch.')); return; }
      fmt = S.fotoKleinFmt; n = 1; quelle = 'e:' + S.fotoKleinKey;
      body = { image:S.fotoKlein, stil:S.stil, format:fmt, zeile1:'', dev:(window.apDevId ? window.apDevId() : ''), grant:(window.apGrant ? window.apGrant() : '') };
    }
    for (var i = 0; i < S.werke.length; i++) {
      if (S.werke[i].quelle === quelle && S.werke[i].stil === S.stil) { S.aktiv = i; S.phase = 'vorschau'; renderAlles(); nachOben(); return; }
    }
    var stil = S.stil, stilName = S.stilName;
    S.busy = true; knoepfe(); if (!weiter) ladeAn('gen');
    var fertig = function(d){
      if (d === null) { netzfehler(); return; }
      if (d && d.ok && d.preview) {
        var pre = new Image();
        var zeig = function(){
          S.werke.push({ url:d.preview, stil:stil, stilName:stilName, modus:fam ? 'familie' : 'einzel', motive:n, koepfe:(fam ? koepfeFotos() : 0), fmt:fmt, quelle:quelle, sim:!!d.sim });
          S.aktiv = S.werke.length - 1; S.busy = false; S.phase = 'vorschau';
          if (S.mat === 'framed_canvas' && preisFuer(S.werke[S.aktiv], 'framed_canvas', S.gr) === null) S.gr = 'm';
          speichern(); ladeAus(); renderAlles(); nachOben(); zaehl('vorschau');
        };
        pre.onload = zeig; pre.onerror = zeig; pre.src = d.preview;
        return;
      }
      fehler(d, 'gen');
    };
    if (SIM) {
      var tab = fam ? D.beispiel.werkF : D.beispiel.werkE;
      setTimeout(function(){ fertig({ ok:true, preview: tab[stil] || tab.aquarell, sim:true }); }, SEK_GEN * 1000 / TEMPO);
      return;
    }
    window.apJobSenden(body, 'gen', fertig, { stil:stil, stilName:stilName, format:fmt, seite:'ft', modus:fam ? 'familie' : 'einzel', motive:n });
  }
  function netzfehler(){
    S.busy = false; ladeAus(); knoepfe(); zaehl('fehler');
    box(T('Das hat gerade nicht geklappt'), '<p>' + T('Das Kunstwerk konnte diesmal nicht erstellt werden. Es wurde nichts angerechnet. Bitte versuche es noch einmal.') + '</p>');
  }
  function fehler(d, art){
    S.busy = false; ladeAus(); knoepfe(); zaehl('fehler');
    if (d && d.error === 'zu_viele_personen') {   /* AP-GRUPPE-3110: Worker hat vor der Erzeugung gesperrt (nichts angerechnet) */
      S.gruppeServer = fotoIds(); zaehl('f_gruppe'); renderFotos(); knoepfe();
      box(T('Zu viele Personen'), '<p>' + persMax() + '</p>'); return;
    }
    if (d && d.error === 'limit' && d.grund === 'mailgate') { lsSet('apMailGrant', null); nlAuf(M === 'de' ? d.message : ''); return; }
    if (d && d.error === 'limit') { box(T('Für heute geschafft'), '<p>' + esc(M === 'de' ? (d.message || 'Tageslimit erreicht. Morgen geht es weiter.') : T('Tageslimit erreicht. Morgen geht es weiter.')) + '</p>'); return; }
    if (d && d.error === 'quelle') { S.merged = null; S.mergedKey = ''; }
    var grund = (d && (d.message || d.error)) ? String(d.message || d.error) : '';
    if (M !== 'de') grund = (d && d.error === 'bot') ? T('Sicherheitsprüfung fehlgeschlagen. Bitte lade die Seite neu.') : '';   /* Worker-Meldungen sind deutsch */
    if (art === 'merge') {
      box(T('Die Zusammenführung hat nicht geklappt'), '<p>' + esc(grund) + '</p><p>' + T('Meist hilft: Fotos direkt aus der Galerie (keine Screenshots), jedes Gesicht gut sichtbar. Versuch es gleich noch einmal, es kostet nichts.') + '</p>');
    } else {
      box(T('Das hat diesmal nicht geklappt'), (grund ? '<p>' + esc(grund) + '</p>' : '') + '<p>' + T('Es wurde nichts angerechnet. Bitte versuche es noch einmal.') + '</p>');
    }
  }
  function tzAnker(){ return O('ftTiefst'); }   /* AP-ZEHN-A-0111: Aufpreis-Zeile steht direkt unter der Tiefstpreis-Zeile */
  function nachOben(){
    var v = $('#ftVorschau'); if (!v) return;
    setTimeout(function(){ try { v.scrollIntoView({ behavior:'smooth', block:'start' }); } catch (e) { v.scrollIntoView(); } }, 60);
  }

  /* ── Preise und Varianten ── */
  function tabelle(w){ return (w && w.modus === 'familie') ? (D.preise.fam[String(w.motive > 4 ? 4 : w.motive)] || D.preise.fam['2']) : D.preise.einzel; }
  function vidFuer(w, mat, gr){
    var V = (w && w.modus === 'familie') ? (D.vids.fam[String(w.motive > 4 ? 4 : w.motive)] || null) : D.vids.einzel;
    if (!V) return '';
    if (mat === 'framed_canvas') return ((V.framed_canvas || {})[S.farbe] || {})[gr] || '';
    return (V.canvas || {})[gr] || '';
  }
  function variante(w){ return vidFuer(w, S.mat, S.gr); }
  /* Preis: Tabelle (wie AP_PREISE/FAM_PREISE) entscheidet, ob es die Groesse gibt.
     Der Betrag kommt, wenn vorhanden, direkt aus Shopify (D.shop = Varianten-ID -> Cent). */
  var preisWarn = {};
  function preisFuer(w, mat, gr){
    var t = tabelle(w), p = zahl((t[mat] || t.canvas)[gr]);
    if (p === null) return null;
    var v = vidFuer(w, mat, gr);
    if (D.shop && v && D.shop[v] !== undefined && D.shop[v] !== null) {
      var sp = D.shop[v] / 100;
      if (Math.abs(sp - p) > 0.001 && !preisWarn[v]) { preisWarn[v] = 1; try { console.warn('[Fast Track] Preis weicht ab: Variante ' + v + ' Tabelle ' + p + ' Shopify ' + sp); } catch (e) {} }
      return sp;
    }
    return p;
  }
  function masse(gr, fmt){ if (M === 'us') { var z = ZOLL[gr]; return fmt === 'quer' ? (z[1] + ' × ' + z[0] + '"') : (z[0] + ' × ' + z[1] + '"'); } var c = CM[gr]; return fmt === 'quer' ? (c[1] + ' × ' + c[0] + ' cm') : (c[0] + ' × ' + c[1] + ' cm'); }
  function groesseProp(gr, fmt){ if (M === 'us') { var z = ZOLL[gr]; return fmt === 'quer' ? (z[1] + '×' + z[0] + '"') : (z[0] + '×' + z[1] + '"'); } var c = CM[gr]; return fmt === 'quer' ? (c[1] + '×' + c[0] + ' cm') : (c[0] + '×' + c[1] + ' cm'); }   /* wie apSzName */

  /* ── Rendern ── */
  function renderAlles(){ renderPhase(); renderFotos(); renderStile(); renderVorschau(); renderKauf(); knoepfe(); }
  function renderPhase(){
    if (S.phase === 'vorschau' && S.aktiv < 0) S.phase = S.fotos.length ? 'fotos' : 'start';
    if (S.phase === 'fotos' && !S.fotos.length) S.phase = S.werke.length ? 'vorschau' : 'start';
    root.setAttribute('data-phase', S.phase);
    var stt = $('#ftStileTitel'); if (stt) stt.textContent = S.phase === 'vorschau' ? T('Noch einen Stil ausprobieren?') : T('Stil wählen');
    var stn = $('#ftStileNr'); if (stn) stn.hidden = S.phase === 'vorschau';
    var st = { start:1, fotos:2, vorschau:3 }[S.phase];
    $$('.ft-schritte li').forEach(function(li){
      var n = parseInt(li.getAttribute('data-s'), 10);
      li.classList.toggle('on', n === st); li.classList.toggle('ok', n < st);
    });
    $$('.ft-chip.ak').forEach(function(c){ c.hidden = !aktionAn(); });
  }
  /* AP-FT-FOTOREIHE-3110: Reihenfolge per Ziehen. Maus: ab 6 px Bewegung. Touch: erst nach 280 ms Halten (vorher = Reihe scrollen).
     Tastatur: Kachel fokussieren, Pfeil links/rechts. Reihenfolge der Fotos = Reihenfolge an den Worker. */
  var fotoNVor = 0, ZG = null;
  function zgZiel(x){ var n = 0; $$('#ftFGrid .ft-tile').forEach(function(t){ if (t === ZG.t) return; var r = t.getBoundingClientRect(); if (x > r.left + r.width / 2) n++; }); return n; }
  function zgMarke(ziel){
    var andere = $$('#ftFGrid .ft-tile').filter(function(t){ return t !== ZG.t; });
    andere.forEach(function(t, i){ t.classList.toggle('ziel-vor', i === ziel); t.classList.toggle('ziel-nach', ziel === andere.length && i === andere.length - 1); });
  }
  function zgVerschieben(id, ziel){
    var i = -1; S.fotos.forEach(function(f, k){ if (f.id === id) i = k; });
    if (i < 0 || ziel === i) return false;
    var f = S.fotos.splice(i, 1)[0]; S.fotos.splice(Math.max(0, Math.min(ziel, S.fotos.length)), 0, f);
    return true;
  }
  function zgStart(){
    ZG.an = true; ZG.t.classList.add('zieht'); ZG.sl = $('#ftFGrid').scrollLeft; $('#ftFGrid').classList.add('sortiert');   /* Reihe nur durch eigenes Rand-Scrollen bewegen (Browser scrollt sonst beim Ziehen mit) */
    try { ZG.t.setPointerCapture(ZG.pid); } catch (x) {}
    try { if (navigator.vibrate && ZG.touch) navigator.vibrate(12); } catch (x) {}
  }
  function zgBewegen(x, y){
    ZG.lx = x;
    ZG.t.style.transform = 'translate(' + (x - ZG.x0) + 'px,' + (y - ZG.y0) * 0.3 + 'px) scale(1.06)';
    var g = $('#ftFGrid'), r = g.getBoundingClientRect();
    if (x < r.left + 28) ZG.sl = Math.max(0, ZG.sl - 10); else if (x > r.right - 28) ZG.sl = Math.min(g.scrollWidth - g.clientWidth, ZG.sl + 10);
    g.scrollLeft = ZG.sl;
    zgMarke(zgZiel(x));
  }
  function zgEnde(){
    var ziel = zgZiel(ZG.lx == null ? ZG.x0 : ZG.lx), id = ZG.id;
    ZG.t.classList.remove('zieht'); ZG.t.style.transform = ''; $('#ftFGrid').classList.remove('sortiert');
    $$('#ftFGrid .ft-tile').forEach(function(t){ t.classList.remove('ziel-vor', 'ziel-nach'); });
    if (zgVerschieben(id, ziel)) renderAlles();
  }
  (function(){
    var g = $('#ftFGrid'); if (!g) return;
    g.addEventListener('pointerdown', function(e){
      if (S.busy || S.fotos.length < 2 || (e.button !== undefined && e.button !== 0)) return;
      var t = e.target.closest ? e.target.closest('.ft-tile') : null; if (!t || e.target.closest('button')) return;
      ZG = { t:t, id:parseInt(t.getAttribute('data-id'), 10), x0:e.clientX, y0:e.clientY, lx:null, an:false, pid:e.pointerId, touch:e.pointerType !== 'mouse', timer:null };
      if (ZG.touch) ZG.timer = setTimeout(function(){ if (ZG && !ZG.an) zgStart(); }, 280);
    });
    g.addEventListener('pointermove', function(e){
      if (!ZG || e.pointerId !== ZG.pid) return;
      var dx = e.clientX - ZG.x0, dy = e.clientY - ZG.y0;
      if (!ZG.an) {
        if (ZG.touch) { if (Math.abs(dx) > 8 || Math.abs(dy) > 8) { clearTimeout(ZG.timer); ZG = null; } return; }
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        zgStart();
      }
      if (e.cancelable) e.preventDefault();
      zgBewegen(e.clientX, e.clientY);
    });
    function ende(e){ if (!ZG || (e && e.pointerId !== ZG.pid)) return; clearTimeout(ZG.timer); var z = ZG; if (z.an) zgEnde(); ZG = null; }
    g.addEventListener('pointerup', ende); g.addEventListener('pointercancel', ende);
    g.addEventListener('touchmove', function(e){ if (ZG && ZG.an && e.cancelable) e.preventDefault(); }, { passive:false });
    g.addEventListener('contextmenu', function(e){ if (ZG) e.preventDefault(); });
    g.addEventListener('dragstart', function(e){ e.preventDefault(); });
    g.addEventListener('keydown', function(e){
      if (S.busy || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var t = e.target.closest ? e.target.closest('.ft-tile') : null; if (!t || e.target !== t) return;
      var id = parseInt(t.getAttribute('data-id'), 10), i = -1; S.fotos.forEach(function(f, k){ if (f.id === id) i = k; });
      e.preventDefault();
      if (zgVerschieben(id, i + (e.key === 'ArrowLeft' ? -1 : 1))) { renderAlles(); var n = $('#ftFGrid .ft-tile[data-id="' + id + '"]'); if (n) n.focus(); }
    });
  })();
  function renderFotos(){
    var g = $('#ftFGrid'); if (!g) return;
    var n = S.fotos.length, fam = n >= 2;
    g.setAttribute('data-n', n); if (n > 4) g.setAttribute('data-viele', '1'); else g.removeAttribute('data-viele'); g.setAttribute('data-fmt', n === 1 ? fmtEinzel(S.fotos[0]) : 'hoch');
    var h = '';
    S.fotos.forEach(function(f, i){
      var ratio = ratioFoto(f), quer = !fam && ratio > 1, src = '';
      try { src = zuschnitt(f, ratio, 520, 0.82); } catch (e) {}
      var klein = fam && !SIM && Math.max(f.w, f.h) < 600;
      var gh = klein ? null : gsHinweis(f, fam, i + 1);   /* AP-GESICHT-0111 */
      h += '<div class="ft-tile' + (quer ? ' quer' : (fam ? '' : ' hoch1')) + (fam ? ' ganz' : '') + (klein ? ' schlecht' : (gh ? ' hinweis' : '')) + '" data-id="' + f.id + '" tabindex="0">'
        + (fam ? '<span class="ft-tile-nr" aria-hidden="true">' + (i + 1) + '</span>' : '')
        + '<img src="' + src + '" alt="' + T('Dein Foto {n}', { n:i + 1 }) + '">'
        + (klein ? '<div class="ft-tile-w">' + T('Zu klein, bitte Original nehmen') + '</div>'
                 : (gh ? '<button type="button" class="ft-tile-w hinw" data-gs="' + f.id + '">' + esc(gh.kurz) + '</button>' : ''))   /* AP-GESICHT-0111 */
        + '<button type="button" class="ft-tile-x" data-weg="' + f.id + '" aria-label="' + T('Foto {n} entfernen', { n:i + 1 }) + '">×</button>'
        + '<button type="button" class="ft-tile-cut" data-cut="' + f.id + '" aria-label="' + T('Ausschnitt von Foto {n} anpassen', { n:i + 1 }) + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2v14a2 2 0 0 0 2 2h14"/><path d="M18 22V8a2 2 0 0 0-2-2H2"/></svg><b>' + T('Ausschnitt') + '</b></button></div>';
    });
    if (n < MAXF) h += '<button type="button" class="ft-tile-add" data-plus="1"><i>+</i>' + (n === 0 ? T('Foto wählen') : (n === 1 ? T('Person oder Tier dazu') : T('Foto dazu'))) + '</button>';
    g.innerHTML = h;
    if (n > fotoNVor) { try { g.scrollLeft = g.scrollWidth; } catch (e) {} }   /* AP-FT-FOTOREIHE-3110: neues Foto und + sichtbar */
    fotoNVor = n; var so = $('#ftSort'); if (so) so.hidden = n < 2;
    var tp = $('#ftTipps'); if (tp && (g.querySelector('.ft-tile.schlecht') || g.querySelector('.ft-tile.hinweis'))) tp.open = true;   /* AP-FT-OPTIK-3110 + AP-GESICHT-0111 */
    if (tp && n >= GS.tippsAb && !tp.getAttribute('data-auf5')) { tp.open = true; tp.setAttribute('data-auf5', '1'); }   /* AP-GESICHT-0111: ab 5 Fotos einmal aufklappen */
    var gl = O('ftGesicht'), gtx = [];   /* AP-GESICHT-0111: Saetze unter der Fotoreihe */
    S.fotos.forEach(function(f, i){ var hh = (fam && !SIM && Math.max(f.w, f.h) < 600) ? null : gsHinweis(f, fam, i + 1); if (hh) gtx = gtx.concat(hh.saetze); });
    if (!gl && gtx.length) { gl = document.createElement('div'); gl.id = 'ftGesicht'; gl.className = 'ft-gesicht'; gl.setAttribute('role', 'status'); g.parentNode.insertBefore(gl, g.nextSibling); }
    if (gl) { gl.hidden = !gtx.length; gl.innerHTML = gtx.length ? '<p>' + gtx.map(esc).join('</p><p>') + '</p><p class="ft-gesicht-ok">' + esc(tx('gs_trotzdem')) + '</p>' : ''; }
    var k = $('#ftFotosTitel'); if (k) k.textContent = n === 1 ? T('Dein Foto') : T('Deine {n} Fotos', { n:n });
    var z = $('#ftFotosZahl'); if (z) z.textContent = mx(T('{n} von 4'), { n:n });
    var ah = O('ftAufHinweis'), mo = $('#ftModus');   /* AP-ZEHN-A-0111: Erklaerung ab dem 5. Foto */
    if (!ah && mo && mo.parentNode) { ah = document.createElement('p'); ah.id = 'ftAufHinweis'; ah.className = 'ft-auf-hinweis'; ah.setAttribute('role', 'status'); mo.parentNode.insertBefore(ah, mo.nextSibling); }
    if (ah) { var azg = AUF_OK && n >= ZC.ab; ah.hidden = !azg; ah.innerHTML = azg ? esc(aufReihe()) + aufWarum() : ''; }
    var m = $('#ftModus');
    if (m) {
      if (n === 1) m.innerHTML = T('<b>Ein Foto = ein Kunstwerk.</b><span>Mehrere Fotos? Füge sie hinzu, wir vereinen alle zu einem Bild.</span>');
      else if (n >= 2) m.innerHTML = T('<b>{n} Fotos = ein gemeinsames Kunstwerk.</b><span>Wir vereinen alle zu einem Bild.</span>', { n:n });
      else m.innerHTML = '';
    }
    var ff = $('#ftFormat');
    if (ff) {
      ff.hidden = n < 2;
      var emp = famEmpf(n), jetzt = famFmt();
      $$('[data-ffmt]', ff).forEach(function(b){
        var f = b.getAttribute('data-ffmt');
        b.classList.toggle('on', f === jetzt); b.setAttribute('aria-pressed', f === jetzt);
        b.innerHTML = (f === 'hoch' ? T('Hochformat') : T('Querformat')) + (f === emp ? ' <small>' + T('empfohlen') + '</small>' : '');
      });
    }
    var gs = gruppeStand(), gh = O('ftGruppe');   /* AP-GRUPPE-3110: Hinweis unter dem Format (Sperre steht auf dem Knopf) */
    if (!gh && ff && ff.parentNode) { gh = document.createElement('p'); gh.id = 'ftGruppe'; gh.className = 'ft-pershinweis'; gh.setAttribute('role', 'status'); ff.parentNode.insertBefore(gh, ff.nextSibling); }
    if (gh) {
      var gt = gs === 'pruefen' ? T('Bei so vielen Personen: bitte die Vorschau genau prüfen, ob alle drauf sind.')
             : (gs === 'einzelviele' ? T('Bei sehr vielen Personen werden die Gesichter klein. Für große Leinwände lieber ein Foto mit weniger Personen.') : '');
      gh.textContent = gt; gh.hidden = !gt;
    }
    var zur = $('#ftZurVorschau'); if (zur) zur.hidden = !S.werke.length;
  }
  function stilGesperrt(id){
    if (S.fotos.length !== 1) return false;
    var mo = S.fotos[0].motiv; if (!mo) return false;
    var sp = (SPERREN[mo] || []).filter(function(x){ return x !== 'regenbogenbruecke'; });   /* 19.07.: fuer alle Motive frei */
    return sp.indexOf(id) > -1;
  }
  function renderStile(){
    var fam = S.fotos.length >= 2 || (!S.fotos.length && S.aktiv > -1 && S.werke[S.aktiv].modus === 'familie');
    if (stilGesperrt(S.stil)) { S.stil = 'aquarell'; S.stilName = T('Aquarell'); }
    var orig = origDa(); if (S.stil === 'original' && !orig) { S.stil = 'aquarell'; S.stilName = T('Aquarell'); }   /* AP-FT-ORIGINAL-3110 */
    ['top','mehr','andenken'].forEach(function(gr){
      var wrap = $('[data-gruppe="' + gr + '"]'); if (!wrap) return;
      var h = '';
      if (gr === 'top' && orig) h += '<button type="button" class="ft-stil ft-stil-orig' + (S.stil === 'original' ? ' on' : '') + '" data-stil="original" aria-pressed="' + (S.stil === 'original') + '">'
        + '<img src="' + esc(S.merged) + '" alt="' + T('Beispiel im Stil {s}', { s:esc(ORIG_NAME) }) + '" decoding="async"><span lang="' + (M === 'de' ? 'de' : 'en') + '">' + esc(ORIG_NAME) + '</span></button>';
      D.stile.filter(function(s){ return s.gruppe === gr; }).forEach(function(s){
        var gesp = stilGesperrt(s.id);
        h += '<button type="button" class="ft-stil' + (s.id === S.stil ? ' on' : '') + '" data-stil="' + s.id + '"' + (gesp ? ' disabled title="' + T('Passt nicht zu diesem Motiv') + '"' : '') + ' aria-pressed="' + (s.id === S.stil) + '">'
          + '<img' + (/-rand$/.test(s.id) ? ' class="ft-rand"' : '') + ' src="' + esc(bildM(fam ? (s.imgF || s.img) : s.img)) + '" alt="' + T('Beispiel im Stil {s}', { s:esc(stilNm(s)) }) + '" loading="lazy" decoding="async"><span lang="' + (M === 'de' ? 'de' : 'en') + '">' + esc(stilNm(s)).replace(TRENN_RE, function(w){ return TRENN[w]; }) + '</span></button>';
      });
      wrap.innerHTML = h;
    });
    $$('.ft-mehrteil').forEach(function(x){ x.hidden = !S.mehr; });
    var mb = $('#ftMehr'); if (mb) mb.textContent = S.mehr ? T('Weniger Stile zeigen') : T('Alle 22 Stile zeigen');
    var hinweis = $('#ftStilHinweis'); if (hinweis) hinweis.hidden = !(SIM && fam && ['top'].indexOf((D.stile.filter(function(s){ return s.id === S.stil; })[0] || {}).gruppe) < 0);
  }
  function renderVorschau(){
    var w = S.werke[S.aktiv]; if (!w) return;
    var b = $('#ftBild'), img = $('#ftBildImg');
    if (img.getAttribute('src') !== w.url) img.src = w.url;
    img.alt = T('Vorschau deines Kunstwerks im Stil {s}', { s:w.stilName });
    b.className = 'ft-bild mat-' + S.mat + ' farbe-' + S.farbe;
    $('#ftBadge').textContent = w.stilName + (w.sim ? T(' · Beispielbild') : '');
    var strip = $('#ftWerke');
    if (strip) {
      if (S.werke.length > 1) {
        var h = '';
        S.werke.forEach(function(x, i){ h += '<button type="button" class="ft-werk' + (i === S.aktiv ? ' on' : '') + '" data-werk="' + i + '" aria-label="' + T('Vorschau {s} anzeigen', { s:esc(x.stilName) }) + '"><img src="' + esc(x.url) + '" alt=""></button>'; });
        strip.innerHTML = h; strip.hidden = false;
      } else { strip.innerHTML = ''; strip.hidden = true; }
    }
  }
  function renderKauf(){
    var w = S.werke[S.aktiv]; if (!w) return;
    var dlp = $('#ftDlPreis'); if (dlp) dlp.textContent = euro(w.modus === 'familie' ? 49.9 : 29.9);   /* AP-FT-DL-3110 */
    $$('.ft-opt[data-mat]').forEach(function(b){ b.classList.toggle('on', b.getAttribute('data-mat') === S.mat); b.setAttribute('aria-pressed', b.getAttribute('data-mat') === S.mat); });
    var fz = $('#ftFarbZeile'); if (fz) fz.hidden = S.mat !== 'framed_canvas';
    $$('.ft-farbe').forEach(function(b){ b.classList.toggle('on', b.getAttribute('data-farbe') === S.farbe); b.setAttribute('aria-pressed', b.getAttribute('data-farbe') === S.farbe); });
    /* Groessen, die es im gewaehlten Material nicht gibt (L mit Rahmen), werden ausgeblendet und darunter erklaert */
    var g = $('#ftGr'), h = '', nGr = 0, nurLw = [];
    /* AP-ZEHN-A-0111: Groessensperre nach Koepfen. Gewaehlte Groesse gesperrt -> kleinste erlaubte, die es im Material gibt */
    if (grGesperrt(w, S.gr) || preisFuer(w, S.mat, S.gr) === null) { for (var gi = 0; gi < GR.length; gi++) { if (!grGesperrt(w, GR[gi]) && preisFuer(w, S.mat, GR[gi]) !== null) { if (grGesperrt(w, S.gr)) S.gr = GR[gi]; break; } } }
    var gesp = [];
    GR.forEach(function(gr){
      var p = preisFuer(w, S.mat, gr);
      if (p !== null && grGesperrt(w, gr)) { gesp.push(gr); h += '<button type="button" class="ft-g aus" data-gr="' + gr + '" disabled aria-disabled="true">'
        + '<b>' + gr.toUpperCase() + '</b><span class="cm">' + masse(gr, w.fmt) + '</span><span class="pr">' + esc(tx('gr_gesperrt', { n:GR_KOEPFE[gr] })) + '</span></button>'; nGr++; return; }
      if (p === null) { if (S.mat === 'framed_canvas' && preisFuer(w, 'canvas', gr) !== null) nurLw.push(gr); return; }
      nGr++;
      h += '<button type="button" class="ft-g' + (gr === S.gr ? ' on' : '') + '" data-gr="' + gr + '" aria-pressed="' + (gr === S.gr) + '">'
        + '<b>' + gr.toUpperCase() + '</b><span class="cm">' + masse(gr, w.fmt) + '</span><span class="pr">' + euro(p) + '</span></button>';
    });
    g.innerHTML = h; g.setAttribute('data-n', nGr);
    var gh = $('#ftGrHinweis');
    if (gh) { gh.hidden = !nurLw.length; gh.textContent = nurLw.map(function(gr){ return T('Größe {g} ({m})', { g:gr.toUpperCase(), m:masse(gr, w.fmt) }); }).join(', ') + T(' gibt es nur als Leinwand ohne Rahmen.'); }
    var ph = O('ftPersGr');   /* AP-ZEHN-A-0111 */
    if (!ph && g && g.parentNode) { ph = document.createElement('p'); ph.id = 'ftPersGr'; ph.className = 'ft-pers-gr'; ph.setAttribute('role', 'status'); g.parentNode.insertBefore(ph, g.nextSibling); }
    if (ph) { var ab0 = ''; GR.forEach(function(gr){ if (!ab0 && gesp.indexOf(gr) < 0 && preisFuer(w, S.mat, gr) !== null) ab0 = gr.toUpperCase(); });
      ph.textContent = gesp.length ? tx('gr_hinweis', { n:koepfe(w), g:ab0 }): '';
      ph.hidden = !gesp.length; }
    var p = preisFuer(w, S.mat, S.gr), au = aufFuer(w);
    $('#ftPreis').textContent = p === null ? '' : euro(p + (au ? au.betrag : 0));   /* AP-ZEHN-A-0111: Summe inkl. Aufpreis */
    var apz = O('ftAufpreis'), pz = $('#ftPreis');
    if (!apz && tzAnker()) { apz = document.createElement('p'); apz.id = 'ftAufpreis'; apz.className = 'ft-aufpreis'; tzAnker().parentNode.insertBefore(apz, tzAnker().nextSibling); }
    if (apz) { apz.hidden = !(au && p !== null); apz.innerHTML = (au && p !== null) ? esc(aufZeile(au, p)) + aufWarum() : ''; }
    var mi = $('#ftMatInfo');
    if (mi) mi.textContent = (S.mat === 'canvas' ? T('Leinwand mit 4 cm Galerietiefe, fertig zum Aufhängen.') : T('Leinwand im Schattenfugenrahmen, Rahmen in {f}, fertig zum Aufhängen.', { f:FARBEN[S.farbe] }))
      + (w.modus === 'familie' ? T(' Familienbild aus {n} Fotos.', { n:w.motive }) : '');
    var an = aktionAn();
    $('#ftAktion').hidden = !an;
    var tz = $('#ftTiefst');
    if (an && p !== null && au) { tz.innerHTML = T('Kunstwerk: niedrigster Preis der letzten 30 Tage {p} · <b>mit Aktion im Warenkorb: {a}</b> · dazu {z} Aufpreis ohne Rabatt', { p:euro(p), a:euro(Math.ceil(Math.round(p * 100) * 67 / 100) / 100), z:euro(au.betrag) }); tz.hidden = false; }   /* AP-ZEHN-A-0111 */
    else if (an && p !== null) { tz.innerHTML = T('Niedrigster Preis der letzten 30 Tage: {p} · <b>mit Aktion im Warenkorb: {a}</b>', { p:euro(p), a:euro(Math.ceil(Math.round(p * 100) * 67 / 100) / 100) }); tz.hidden = false; }
    else tz.hidden = true;
    $('#ftLiefer span').textContent = lieferText();
    sticky();   /* AP-FT-STICKY-3110 */
  }
  /* AP-FT-STICKY-3110: fester Knopf unten am Handy */
  function imBild(el){ if (!el || el.hidden || !el.offsetParent) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || 0) - 70; }
  function sticky(){
    var box = $('#ftSticky'), btn = $('#ftStickyBtn'); if (!box || !btn) return;
    var modus = (S.phase === 'vorschau' && S.werke[S.aktiv]) ? 'kauf' : ((S.phase === 'fotos' && S.fotos.length) ? 'gen' : '');
    var ziele = modus === 'kauf' ? [$('#ftKaufen')] : (modus === 'gen' ? [$('#ftCta'), $('#ftCtaOben')] : []);
    var anzeigen = !!modus && !ziele.some(imBild);
    if (modus === 'kauf') { var pr = ($('#ftPreis') || {}).textContent || ''; btn.textContent = T('In den Warenkorb') + (pr ? ' · ' + pr : ''); btn.disabled = S.kaufLaeuft || S.busy; }
    if (modus === 'gen') { var gsp2 = gruppeGesperrt(); btn.textContent = gsp2 ? persMax() : T('Kostenlose Vorschau erstellen'); btn.disabled = S.busy || gsp2; btn.classList.toggle('ft-gesperrt', gsp2); }   /* AP-GRUPPE-3110 */
    else btn.classList.remove('ft-gesperrt');
    btn.setAttribute('data-modus', modus);
    box.hidden = !anzeigen;
    try { document.body.classList.toggle('ft-sticky-an', anzeigen); document.body.classList.toggle('ft-pbar', !!document.getElementById('PBarNextFrame')); } catch (e) {}
  }
  (function(){ var w = false; window.addEventListener('scroll', function(){ if (w) return; w = true; (window.requestAnimationFrame || setTimeout)(function(){ w = false; sticky(); }); }, { passive:true }); window.addEventListener('resize', function(){ sticky(); }); })();
  function knoepfe(){
    var c = $('#ftCta');
    if (c) {
      var fam = S.fotos.length >= 2;
      var gsp = gruppeGesperrt();   /* AP-GRUPPE-3110: ueber 20 Personen (Familie) -> Knopf gesperrt */
      c.disabled = S.busy || gsp; c.classList.toggle('ft-gesperrt', gsp);
      if (gsp) { c.textContent = persMax(); zaehl('fehler'); zaehl('f_gruppe'); }
      else if (S.phase === 'vorschau') c.textContent = T('Vorschau in {s} erstellen', { s:S.stilName });
      else c.textContent = S.fotos.length ? T('Kostenlose Vorschau erstellen') : T('Foto auswählen');
      var k = $('#ftCtaKlein');
      if (k) k.textContent = gsp ? '' : S.fotos.length ? T('Dauert {d} · kostenlos und unverbindlich', { d:(fam ? T('etwa {a} bis {b} Minuten', spanne(erwartetSek(S.merged && S.mergedKey === quelleKey() ? 'gen' : 'merge'))) : T('etwa 1 Minute')) }) : T('Erst die Vorschau, dann entscheidest du.');
    }
    var co = $('#ftCtaOben'), ok = $('#ftObenK');   /* AP-FT-FS2-3110 */
    if (co) { var zeig = S.fotos.length > 0, gso = gruppeGesperrt(); co.hidden = !zeig; co.disabled = S.busy || gso; co.classList.toggle('ft-gesperrt', gso);
      if (!co.getAttribute('data-txt')) co.setAttribute('data-txt', co.textContent); co.textContent = gso ? persMax() : co.getAttribute('data-txt');   /* AP-GRUPPE-3110 */
      if (ok) { ok.hidden = !zeig; ok.textContent = T('Stil: {s} · unten änderbar', { s:S.stilName }); } }
    var kb = $('#ftKaufen'); if (kb) kb.disabled = S.kaufLaeuft || S.busy;
    sticky();   /* AP-FT-STICKY-3110 */
    var dk = $('#ftDownload'); if (dk) dk.disabled = S.kaufLaeuft || S.busy;   /* AP-FT-DL-3110 */
  }

  /* ── Warenkorb (gleicher Weg wie apBuy: Doppel-Pruefung, Properties, dann /cart) ── */
  function kaufen(){
    if (S.kaufLaeuft || S.busy) return;
    var w = S.werke[S.aktiv]; if (!w) return;
    var vid = variante(w);
    if (!vid || vid === '0' || preisFuer(w, S.mat, S.gr) === null || grGesperrt(w, S.gr)) {   /* AP-ZEHN-A-0111: gesperrte Groesse nie kaufen */
      box(T('Nicht verfügbar'), '<p>' + T('Diese Kombination gibt es gerade nicht. Bitte wähle eine andere Größe.') + '</p>'); return; }
    var props = {}; props[T('Kunststil')] = w.stilName; props[T('Größe')] = groesseProp(S.gr, w.fmt); props._artwork_url = w.url;   /* EN/US: Art style, Size wie apBuy */
    if (w.modus === 'familie' && w.motive) props[T('Fotos')] = String(w.motive);   /* AP-ZEHN-A-0111: Anzahl Fotos sichtbar (Variante bleibt '4 Motive' ab 4 Fotos) */
    zaehl('warenkorb');
    if (SIM) {
      box('Liegt im Warenkorb', '<p><b>Im Shop</b> landet jetzt genau dieses Kunstwerk im Warenkorb (' + esc(S.mat === 'canvas' ? 'Leinwand' : 'gerahmt, ' + FARBEN[S.farbe]) + ', ' + esc(masse(S.gr, w.fmt)) + ').</p><p>Danach öffnet sich der Warenkorb. Dort ist der Aktionsrabatt schon abgezogen, dann geht es zur Kasse.</p><p style="font-size:12.5px;color:#6E665E">Entwurf: Variante ' + esc(vid) + ' · Kunststil ' + esc(w.stilName) + ' · Größe ' + esc(props[T('Größe')]) + '</p>', 'Weiter ansehen');
      return;
    }
    S.kaufLaeuft = true; knoepfe();
    fetch(PFX + '/cart.js').then(function(r){ return r.json(); }).catch(function(){ return { items:[] }; })
      .then(function(c){
        /* AP-ZEHN-A-0111: ab 5 Fotos Kunstwerk + Aufpreis in EINEM Aufruf (items), gemeinsame _ap_gruppe */
        var its = c.items || [], au = aufFuer(w), alt = null, posten = [];
        its.forEach(function(it){ var p = it.properties || {}; if (String(it.variant_id) === String(vid) && p._artwork_url === w.url) alt = it; });
        function aufPos(g){ var pp = { _ap_gruppe:g, _ap_aufpreis:'1' }; pp[T('Fotos')] = String(w.motive); return { id:au.id, quantity:1, properties:pp }; }
        if (alt) {
          var g0 = (alt.properties || {})._ap_gruppe;
          if (!au || !g0 || its.some(function(it){ var p = it.properties || {}; return p._ap_aufpreis && p._ap_gruppe === g0; })) return { _schonDrin:true };
          posten.push(aufPos(g0));
        } else {
          var gid = au ? gruppeId() : '';
          if (au) props._ap_gruppe = gid;
          if (au) posten.push(aufPos(gid));   /* AP-ZEHN-A-0111-REIHE: Aufpreis ZUERST senden. Shopify zeigt die zuletzt gesendete Position oben (gemessen 01.11. auf DEV), so steht das Kunstwerk oben und der Aufpreis darunter */
          posten.push({ id:vid, quantity:1, properties:props });
        }
        return fetch(PFX + '/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ items:posten }) }).then(function(r){ return r.json(); });
      })
      .then(function(d){
        if (d && (d.status === 422 || d.description)) { S.kaufLaeuft = false; knoepfe(); box(T('Warenkorb'), '<p>' + esc(d.description) + '</p>'); return; }
        window.location.href = PFX + '/cart';
      })
      .catch(function(){ S.kaufLaeuft = false; knoepfe(); box(T('Warenkorb'), '<p>' + T('Das hat nicht geklappt. Bitte versuche es noch einmal.') + '</p>'); });
  }

  /* AP-FT-DL-3110: Download wie apBuyDL der Hauptseite (Warenkorb leeren, nur die Datei, direkt zur Kasse) */
  var DLV = { einzel:'53282865250570', familie:'53388104335626' };   /* AP-ZEHN-A-0111: Download ohne Aufpreis (offen: Niklas) */
  function downloadKaufen(){
    if (S.kaufLaeuft || S.busy) return;
    var w = S.werke[S.aktiv]; if (!w) return;
    if (M === 'us') return;   /* AP-FT-EN-3110: auf us.arturell.com kein Download */
    var vid = w.modus === 'familie' ? DLV.familie : DLV.einzel;
    var props = {}; props[T('Kunststil')] = w.stilName; props._artwork_url = w.url;
    if (w.modus === 'familie' && w.motive) props[T('Fotos')] = String(w.motive);   /* AP-ZEHN-A-0111 */
    zaehl('download');
    if (SIM) { box('Download', '<p>Im Shop landet jetzt nur die Datei im Warenkorb, danach geht es direkt zur Kasse.</p>'); return; }
    S.kaufLaeuft = true; knoepfe();
    fetch(PFX + '/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
      .then(function(){ return fetch(PFX + '/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id:vid, quantity:1, properties:props }) }); })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (d && (d.status === 422 || d.description)) { S.kaufLaeuft = false; knoepfe(); box('Download', '<p>' + esc(d.description) + '</p>'); return; }
        window.location.href = PFX + '/checkout';
      })
      .catch(function(){ S.kaufLaeuft = false; knoepfe(); box('Download', '<p>' + T('Das hat nicht geklappt. Bitte versuche es noch einmal.') + '</p>'); });
  }

  /* ── E-Mail-Freischaltung (gleiche Endpunkte wie Mailgate: /mailgate/start und /verify) ── */
  var NL = { mail:'' };
  function nlAuf(msg){
    var o = O('ftNl'); if (!o) return;
    $('.ft-nl-a', o).hidden = false; $('.ft-nl-b', o).hidden = true; $('.ft-nl-err', o).hidden = true;
    if (msg) $('.ft-nl-sub', o).textContent = msg;
    var b = $('.ft-nl-start', o); b.disabled = false; b.textContent = T('Newsletter abonnieren & freischalten');
    o.hidden = false;
    nlCaptcha();   /* AP-FT-CAPTCHA-3110: frueh binden, damit hCaptcha beim Absenden bereit ist */
  }
  function nlFehler(t){ var e = $('.ft-nl-err', O('ftNl')); e.textContent = t; e.hidden = false; }
  function nlFormAbschicken(){
    /* wie apMgFallback: regulaer zu Shopify (Newsletter-Einwilligung), Redirect zurueck mit ?nl=1.
       Der Stand (Vorschauen) liegt vorher in localStorage und wird nach dem Zurueckkommen geladen. */
    var f = O('ftNlForm'); if (!f) return;
    var fi = f.querySelector('input[name="contact[email]"]'); if (fi && NL.mail) fi.value = NL.mail;
    speichern();
    try {   /* AP-FT-CAPTCHA-3110: zurueck auf genau diese Seite (inkl. view/preview), dann mit submit-Ereignis absenden */
      var q = new URLSearchParams(location.search); q.delete('nl'); q.delete('customer_posted'); q.set('nl', '1');
      if (f.elements['return_to']) f.elements['return_to'].value = location.pathname + '?' + q.toString();
    } catch (e) {}
    nlCaptcha();
    /* AP-FT-FOTOS-BEHALTEN-3110: Fotos vor dem Neuladen sichern (IndexedDB, sonst sessionStorage verkleinert), dann absenden.
       Am Captcha aendert sich nichts: dasselbe Formular, dasselbe requestSubmit wie bisher. */
    var los = false;
    function senden(){ if (los) return; los = true; try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (x) {} } }
    var sich; try { sich = fotosSichern(); } catch (e) { sich = null; }
    if (sich && sich.then) { sich.then(senden, senden); setTimeout(senden, 5000); } else senden();
  }
  /* AP-FT-CAPTCHA-3110: hCaptcha von Shopify an das versteckte Formular binden (sonst "Missing CAPTCHA token") */
  var nlCaptchaGebunden = false;
  function nlCaptcha(){
    if (SIM || nlCaptchaGebunden) return;
    var f = O('ftNlForm'); if (!f) return;
    nlCaptchaGebunden = true;
    try { if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') { Shopify.captcha.protect(f); return; } } catch (e) {}
    try { var el = f.elements['contact[email]']; if (el) el.dispatchEvent(new FocusEvent('focusin', { bubbles:true })); } catch (e) {}
  }
  function nlStart(){
    var o = O('ftNl'), inp = $('input[type="email"]', o), mail = String(inp.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) { nlFehler(T('Bitte gib eine gültige E-Mail-Adresse ein.')); return; }
    var b = $('.ft-nl-start', o); b.disabled = true; b.textContent = T('Code wird gesendet …');
    NL.mail = mail;
    (window.apTsToken ? window.apTsToken() : Promise.resolve('')).then(function(tk){
      return fetch(D.worker + '/mailgate/start', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ email:mail, tsToken:tk, lang:(M === 'de' ? 'de' : 'en') }) });
    }).then(function(r){ return r.json(); }).then(function(d){
      if (d && (d.ok || d.error === 'cooldown')) { $('.ft-nl-a', o).hidden = true; $('.ft-nl-b', o).hidden = false; $('.ft-nl-mail', o).textContent = mail; $('.ft-nl-err', o).hidden = true; var c = $('.ft-nl-code', o); c.value = ''; try { c.focus(); } catch (e) {} return; }
      b.disabled = false; b.textContent = T('Newsletter abonnieren & freischalten');
      if (d && (d.error === 'email' || d.error === 'limit' || d.error === 'bot' || d.error === 'versand')) { nlFehler(wmg(d, 'Das hat nicht geklappt. Bitte versuche es erneut.')); return; }
      nlFormAbschicken(); O('ftNl').hidden = true; toast(T('Danke für deine Anmeldung!'));   /* Worker nicht bereit: altes Verhalten */
    }).catch(function(){ b.disabled = false; b.textContent = T('Newsletter abonnieren & freischalten'); nlFehler(T('Verbindungsfehler. Bitte versuche es erneut.')); });
  }
  function nlVerify(){
    var o = O('ftNl'), ok = $('.ft-nl-ok', o); if (ok.disabled) return;
    var code = String($('.ft-nl-code', o).value || '').trim();
    if (!/^[0-9]{6}$/.test(code)) { nlFehler(T('Bitte gib den 6-stelligen Code ein.')); return; }
    ok.disabled = true;
    fetch(D.worker + '/mailgate/verify', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ email:NL.mail, code:code }) })
      .then(function(r){ return r.json(); }).then(function(d){
        ok.disabled = false;
        if (d && d.ok && d.grant) {
          lsSet('apMailGrant', d.grant); lsSet('apfEmailBonus', '1');
          o.hidden = true; toast(T('Geschafft! Deine weiteren Vorschauen sind freigeschaltet.'));
          setTimeout(nlFormAbschicken, 600);
        } else nlFehler(wmg(d, 'Das hat nicht geklappt. Bitte versuche es erneut.'));
      }).catch(function(){ ok.disabled = false; nlFehler(T('Verbindungsfehler. Bitte versuche es erneut.')); });
  }

  /* ── AP-FT-FOTOS-BEHALTEN-3110: hochgeladene Fotos ueberleben die Mail-Freischaltung (Seite laedt neu mit ?nl=1) ──
     Gesichert werden die Originale verkleinert (lange Seite max. 3000 px wie beim Merge) samt Ausschnitt, Motiv, Personen,
     Stil und Format-Wahl. IndexedDB (genug Platz); scheitert sie: sessionStorage stark verkleinert; scheitert das: wie bisher.
     Nach dem Zurueckkommen einmal laden und loeschen, hoechstens 2 Stunden alt. */
  var FB_KEY = 'ftFotos', FB_TTL = 2 * 3600 * 1000;
  function idb(art, wert){
    return new Promise(function(ok){
      var fertig = false, t = setTimeout(function(){ aus(null); }, 3000);
      function aus(v){ if (fertig) return; fertig = true; clearTimeout(t); ok(v); }
      try {
        if (!window.indexedDB) { aus(null); return; }
        var r = window.indexedDB.open('arturell-ft', 1);
        r.onupgradeneeded = function(){ try { r.result.createObjectStore('k'); } catch (e) {} };
        r.onerror = function(){ aus(null); }; r.onblocked = function(){ aus(null); };
        r.onsuccess = function(){
          var db = r.result;
          try {
            var tx = db.transaction('k', art === 'get' ? 'readonly' : 'readwrite'), os = tx.objectStore('k');
            var q = art === 'get' ? os.get(FB_KEY) : (art === 'del' ? os.delete(FB_KEY) : os.put(wert, FB_KEY));
            q.onsuccess = function(){ if (art === 'get') aus(q.result || null); };
            tx.oncomplete = function(){ try { db.close(); } catch (e) {} if (art !== 'get') aus(true); };
            tx.onerror = tx.onabort = function(){ try { db.close(); } catch (e) {} aus(null); };
          } catch (e) { try { db.close(); } catch (x) {} aus(null); }
        };
      } catch (e) { aus(null); }
    });
  }
  function fotoDaten(f, maxL, q){
    var k = Math.min(1, maxL / Math.max(f.w, f.h)), c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(f.w * k)); c.height = Math.max(1, Math.round(f.h * k));
    c.getContext('2d').drawImage(f.img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', q);
  }
  function fotosSichern(){
    if (SIM || !S.fotos.length) return Promise.resolve(false);
    function paket(maxL, q){
      return { t:Date.now(), stil:S.stil, stilName:S.stilName, famFmtWahl:S.famFmtWahl || null, merged:S.merged || null, mergedKey:S.mergedKey || '',
               fotos: S.fotos.map(function(f){ return { id:f.id, src:fotoDaten(f, maxL, q), pos:f.pos, motiv:f.motiv || null,
                 personen:(typeof f.personen === 'number' ? f.personen : null), tiere:(typeof f.tiere === 'number' ? f.tiere : null), gesicht:(f.gesicht || null), gp:(f.gp ? 1 : 0) }; }) };   /* AP-GESICHT-0111 + AP-GESICHT-FIX-0111 */
    }
    var voll = null; try { voll = paket(3000, 0.9); } catch (e) {}
    return (voll ? idb('put', voll) : Promise.resolve(null)).then(function(ok){
      if (ok) return true;
      try { sessionStorage.setItem(FB_KEY, JSON.stringify(paket(1400, 0.82))); return true; } catch (e) {}
      try { sessionStorage.setItem(FB_KEY, JSON.stringify(paket(900, 0.75))); return true; } catch (e) {}
      return false;
    });
  }
  function fotosZurueck(){
    return idb('get').then(function(z){
      if (!z) { try { z = JSON.parse(sessionStorage.getItem(FB_KEY) || 'null'); } catch (e) { z = null; } }
      idb('del'); try { sessionStorage.removeItem(FB_KEY); } catch (e) {}
      if (!z || !z.fotos || !z.fotos.length || Date.now() - (z.t || 0) > FB_TTL || S.fotos.length || S.busy) return false;
      return new Promise(function(fertig){
        var i = 0;
        (function naechstes(){
          if (i >= z.fotos.length || S.fotos.length >= MAXF) { fertig(true); return; }
          var g = z.fotos[i++]; if (!g || !g.src) { naechstes(); return; }
          ladeBild(g.src, null, { gemerkt:g, danach:naechstes });
        })();
      }).then(function(){
        if (!S.fotos.length) return false;
        if (z.stil) { S.stil = z.stil; S.stilName = z.stilName || S.stilName; }
        if (z.famFmtWahl && z.famFmtWahl.n === S.fotos.length) S.famFmtWahl = z.famFmtWahl;
        if (z.merged && S.merged === z.merged && z.mergedKey) S.mergedKey = z.mergedKey;
        S.phase = 'fotos'; renderAlles();
        toast(T('Freigeschaltet! Deine Fotos sind noch da, du kannst direkt weitermachen.'));
        var ziel = O('ftCtaOben'); if (ziel && !ziel.hidden) { try { ziel.scrollIntoView({ behavior:'smooth', block:'center' }); } catch (e) {} }
        return true;
      });
    });
  }

  /* ── Zwischenstand merken (Neuladen, App-Wechsel) ── */
  function speichern(){
    if (SIM) return;
    var z = { t:Date.now(), werke:S.werke.slice(-8), aktiv:Math.min(S.aktiv, 7), merged:S.merged, mergedN:S.mergedN, mergedFmt:S.mergedFmt,
              fotoKlein:S.fotoKlein, fotoKleinFmt:S.fotoKleinFmt, fotoKleinKey:S.fotoKleinKey, stil:S.stil, stilName:S.stilName, mat:S.mat, farbe:S.farbe, gr:S.gr };
    try { localStorage.setItem('ftStand', JSON.stringify(z)); } catch (e) { try { z.fotoKlein = null; localStorage.setItem('ftStand', JSON.stringify(z)); } catch (e2) {} }
  }
  function laden(){
    if (SIM) return;
    try {
      var z = JSON.parse(lsGet('ftStand') || 'null');
      if (!z || Date.now() - (z.t || 0) > 48 * 3600 * 1000 || !z.werke || !z.werke.length) return;
      S.werke = z.werke; S.aktiv = Math.max(0, Math.min(z.aktiv, S.werke.length - 1));
      S.merged = z.merged; S.mergedN = z.mergedN || 0; S.mergedFmt = z.mergedFmt || 'hoch';
      S.fotoKlein = z.fotoKlein; S.fotoKleinFmt = z.fotoKleinFmt || 'hoch'; S.fotoKleinKey = z.fotoKleinKey || '';
      S.stil = z.stil || S.stil; S.stilName = z.stilName || S.stilName; S.mat = z.mat || 'canvas'; S.farbe = z.farbe || 'black'; S.gr = z.gr || 'm';
      S.phase = 'vorschau';
      if (S.werke[S.aktiv].modus === 'einzel') { S.merged = null; } else { S.fotoKlein = null; }
    } catch (e) {}
  }
  function jobWiederaufnehmen(){
    if (SIM || !window.apJobGemerkt || !window.apJobWarten) return;
    var j = window.apJobGemerkt(); if (!j || j.seite !== 'ft' || S.busy) return;
    S.busy = true; ladeAn(j.art === 'merge' ? 'merge' : 'gen', j.t, j.motive); window.apLadeHinweis2();   /* AP-FT-FORTSCHRITT-3110 */
    window.apJobWarten(j.job, function(d){
      S.busy = false;
      if (j.art === 'merge') {
        if (d && d.ok && d.safeUrl) { S.merged = d.safeUrl; S.mergedN = j.motive || 2; S.mergedFmt = j.format || 'hoch'; S.fotoKlein = null; S.stil = j.stil || S.stil; S.stilName = j.stilName || S.stilName; S.mergedKey = ''; speichern(); gen(true); return; }
      } else if (d && d.ok && d.preview) {
        S.werke.push({ url:d.preview, stil:j.stil, stilName:j.stilName, modus:j.modus || 'einzel', motive:j.motive || 1, fmt:j.format || 'hoch', quelle:'r:' + j.job });
        S.aktiv = S.werke.length - 1; S.phase = 'vorschau'; speichern(); ladeAus(); renderAlles(); nachOben(); return;
      }
      ladeAus(); renderAlles();
    }, { ersteMs:400, maxUnbekannt:3, rueckkehr:true });
  }

  /* ── Zaehler (Seite "ft"; der Worker zaehlt sie erst, wenn "ft" in TRICHTER_SEITEN steht) ── */
  var gezaehlt = {};
  function zaehl(e){
    if (SIM || gezaehlt[e]) return; gezaehlt[e] = true;
    var m = M; try { if (navigator.webdriver || String(window.Shopify && Shopify.theme && Shopify.theme.id) === String(D.devTheme)) m = 'dev'; } catch (x) {}
    var u = D.worker + '/z?e=' + e + '&s=ft&m=' + m;
    try { if (navigator.sendBeacon && navigator.sendBeacon(u)) return; } catch (x) {}
    try { fetch(u, { method:'POST', mode:'no-cors', keepalive:true }); } catch (x) {}
  }
  if (!window.apZaehl) window.apZaehl = function(e){ zaehl(e); };

  /* ── Ereignisse ── */
  if (input) input.addEventListener('change', function(e){ dateien(e.target.files); });
  var up = $('#ftUpload');
  if (up) {
    up.addEventListener('click', waehlen);
    up.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); waehlen(); } });
    ['dragenter','dragover'].forEach(function(t){ up.addEventListener(t, function(e){ e.preventDefault(); up.classList.add('drag'); }); });
    ['dragleave','drop'].forEach(function(t){ up.addEventListener(t, function(e){ e.preventDefault(); up.classList.remove('drag'); }); });
    up.addEventListener('drop', function(e){ if (e.dataTransfer) dateien(e.dataTransfer.files); });
  }
  root.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('button,[data-aktion]') : null; if (!t || !root.contains(t)) return;
    var a;
    if ((a = t.getAttribute('data-weg'))) { entfernen(parseInt(a, 10)); return; }
    if ((a = t.getAttribute('data-gs'))) { gsKlick(parseInt(a, 10)); return; }   /* AP-GESICHT-0111 */
    if ((a = t.getAttribute('data-cut'))) { cropOeffnen(parseInt(a, 10)); return; }
    if (t.getAttribute('data-plus')) { waehlen(); return; }
    if ((a = t.getAttribute('data-stil'))) {
      if (S.busy || t.disabled) return;
      if (a === 'original') { if (origDa()) origZeigen(); return; }   /* AP-FT-ORIGINAL-3110: sofort, ohne Worker */
      var s = D.stile.filter(function(x){ return x.id === a; })[0]; if (!s) return;
      S.stil = s.id; S.stilName = stilNm(s); renderStile(); knoepfe();
      if (S.phase === 'start') toast(T('Stil gemerkt. Jetzt noch dein Foto.'));
      return;
    }
    if ((a = t.getAttribute('data-ffmt'))) { if (S.busy) return; S.famFmtWahl = { n:S.fotos.length, fmt:a }; renderFotos(); knoepfe(); zaehl('format'); return; }
    if ((a = t.getAttribute('data-werk'))) { S.aktiv = parseInt(a, 10); renderAlles(); return; }
    if ((a = t.getAttribute('data-mat'))) {
      S.mat = a; var w = S.werke[S.aktiv];
      if (w && preisFuer(w, S.mat, S.gr) === null) {   /* AP-ZEHN-A-0111-RAHMEN: Toast nennt die wirklich gewaehlte Groesse (vorher immer M, auch wenn M gesperrt war) */
        var gAlt = S.gr, gNeu = grAusweich(w, S.mat, gAlt);
        if (gNeu) { S.gr = gNeu; toast(T('Größe {g} ({m}) gibt es nur als Leinwand. Wir haben {n} gewählt.', { g:gAlt.toUpperCase(), m:masse(gAlt, w.fmt), n:gNeu.toUpperCase() + ' (' + masse(gNeu, w.fmt) + ')' })); }
      }
      renderVorschau(); renderKauf(); speichern(); zaehl('material'); return;
    }
    if ((a = t.getAttribute('data-farbe'))) { S.farbe = a; renderVorschau(); renderKauf(); speichern(); return; }
    if ((a = t.getAttribute('data-gr'))) { if (t.disabled) return; S.gr = a; renderKauf(); speichern(); zaehl('groesse'); return; }
    if (t.id === 'ftCta') { starten(); return; }
    if (t.id === 'ftCtaOben') { starten(); return; }   /* AP-FT-FS2-3110 */
    if (t.id === 'ftKaufen') { kaufen(); return; }
    if (t.id === 'ftStickyBtn') { var md = t.getAttribute('data-modus'); if (md === 'kauf') kaufen(); else if (md === 'gen') starten(); return; }   /* AP-FT-STICKY-3110 */
    if (t.id === 'ftDownload') { downloadKaufen(); return; }   /* AP-FT-DL-3110 */
    if (t.id === 'ftMehr') { S.mehr = !S.mehr; renderStile(); return; }
    if (t.id === 'ftAndererStil') { var st = $('#ftStile'); if (st) st.scrollIntoView({ behavior:'smooth', block:'start' }); return; }
    if (t.id === 'ftNeueFotos') { S.phase = 'fotos'; if (!S.fotos.length) { renderAlles(); waehlen(); return; } renderAlles(); return; }
    if (t.id === 'ftZurVorschau') { S.phase = 'vorschau'; renderAlles(); nachOben(); return; }
    if ((a = t.getAttribute('data-beispiel'))) { beispiel(a); return; }
  });
  (function(){
    var b = O('ftBox'); if (b) { $('.ft-box-ok', b).addEventListener('click', boxZu); $('.ft-box-x', b).addEventListener('click', boxZu); b.addEventListener('click', function(e){ if (e.target === b) boxZu(); }); }
    var n = O('ftNl');
    if (n) {
      $('.ft-nl-start', n).addEventListener('click', nlStart);
      $('.ft-nl-ok', n).addEventListener('click', nlVerify);
      $('.ft-nl-code', n).addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); nlVerify(); } });
      $('input[type="email"]', n).addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); nlStart(); } });
      $('.ft-nl-neu', n).addEventListener('click', function(e){ e.preventDefault(); $('.ft-nl-a', n).hidden = false; $('.ft-nl-b', n).hidden = true; var b2 = $('.ft-nl-start', n); b2.disabled = false; b2.textContent = T('Newsletter abonnieren & freischalten'); });
      $('.ft-box-x', n).addEventListener('click', function(){ n.hidden = true; });
    }
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { boxZu(); var c = O('ftCrop'); if (c) c.hidden = true; if (n) n.hidden = true; } });
  })();

  /* Entwurf: Beispiel-Fotos laden */
  function beispiel(art){
    if (!SIM || S.busy) return;
    S.fotos = []; S.merged = null; S.mergedKey = '';
    var liste = art === 'familie' ? D.beispiel.fotoF : D.beispiel.fotoE;
    liste.forEach(function(src){ ladeBild(src, null, { motiv: art === 'familie' ? 'person' : 'tier' }); });
  }

  laden();
  renderAlles();
  jobWiederaufnehmen();
  try {
    if (!SIM && /[?&](nl=1|customer_posted=true)/.test(location.search)) {
      toast(lsGet('apMailGrant') ? T('Geschafft! Deine weiteren Vorschauen sind freigeschaltet.') : T('Danke für deine Anmeldung!'));
      history.replaceState(null, '', location.pathname);
      fotosZurueck();   /* AP-FT-FOTOS-BEHALTEN-3110 */
    }
  } catch (e) {}
  window.ftStand = function(){ var _w = S.werke[S.aktiv]; return { aufOk:AUF_OK, aufpreis:(_w ? aufFuer(_w) : null), koepfe:(_w ? koepfe(_w) : koepfeFotos()), sperre:GR.filter(function(g){ return _w ? grGesperrt(_w, g) : false; }), markt:M, maxf:MAXF, ids:S.fotos.map(function(f){ return f.id; }), phase:S.phase, fotos:S.fotos.length, modus:modus(), stil:S.stil, werke:S.werke.length, mat:S.mat, farbe:S.farbe, gr:S.gr, busy:S.busy, personen:personenSumme(), gruppe:gruppeStand(), original:origDa(),
    dauer_s:(LETZTE_DAUER ? LETZTE_DAUER.dauer_s : null), dauer:LETZTE_DAUER,   /* AP-FT-FORTSCHRITT-3110 */
    lade:(L.an ? { p:Math.round(L.p * 100) / 100, t_s:Math.round((Date.now() - L.t0) / 1000 * TEMPO * 10) / 10, erwartet_s:L.sek, text:L.z } : null) }; };
})();

/* AP-CENT-0211: Aktionspreis wie Shopify (33 % Rabatt abgerundet) */
